/* Allure TecDoc — navegación EN VIVO desde el fitment-api (7.502 vehículos).
   Flujo: Marca(logo) → Modelo → Versión → Categoría → Tipo → Piezas → Ficha.
   MODELO: la ESTRUCTURA (piezas TecDoc con OEM/compatibilidad) se muestra SIEMPRE.
   El PRODUCTO comprable (precio/comprar) sale solo si existe en Shopify (tiene_producto);
   si no, se muestra la ficha informativa + "Consúltanos por WhatsApp". Sin conteos visibles.
   El sitio NO crea productos: solo lee el api (read-only). Identidad Allure. */
(function () {
  var app = document.getElementById('allure-app');
  var API = (app.dataset.apiUrl || '').replace(/\/+$/, '');
  var WA  = (app.dataset.whatsapp || '56986847673').replace(/[^0-9]/g, '');
  var HERO_TITLE = app.dataset.heroTitle || 'Busca el repuesto para tu auto';
  var HERO_SUB = app.dataset.heroSub || 'Elige tu marca para empezar.';
  var BANNER = app.dataset.banner || 'Espacio para banner / anuncios del dueño';
  var BANNER_SUB = app.dataset.bannerSub || '';
  // Barra de medios de pago: imagen unica del tema (assets/allure-metodos-pago.png).
  // La inyecta Liquid como data-pagos-img porque este archivo es JS puro y no puede usar asset_url.
  var PAGOS_IMG = app.dataset.pagosImg || '';
  // Logo de Mercado Pago junto al texto de cuotas: es quien financia las 6 cuotas, y verlo
  // en la fila da la confianza que el texto solo no da. Misma via que PAGOS_IMG (data-attribute).
  var MP_IMG = app.dataset.mpImg || '';
  // Logo de Correos de Chile para el bloque de plazo de entrega (entregaHTML). Misma vía.
  var CORREOS_IMG = app.dataset.correosImg || '';
  var CTX = {};              // contexto de navegación (para breadcrumb + prefill WhatsApp)
  var MEM = {};              // cache de respuestas del api en la sesión
  // Cuando esta MISMA app se monta en una página /products/{handle}, Liquid inyecta window.ALLURE_PRODUCT.
  // En ese caso, los links del header apuntan al buscador (raíz '/'); en el SPA, son hashes internos.
  var ONPROD = !!window.ALLURE_PRODUCT;
  // Página /search (JP 2026-09-16): misma app, montada por sections/allure-busqueda.liquid.
  var ONSEARCH = !ONPROD && !!window.ALLURE_SEARCH;
  var HP = (ONPROD || ONSEARCH) ? '/' : '';

  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function enc(s){ return encodeURIComponent(s); }
  function dec(s){ try { return decodeURIComponent(s||''); } catch(e){ return s||''; } }
  function go(h){ location.hash = h; }
  function slug(s){ return String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''); }
  function waLink(text){ return 'https://wa.me/'+WA+'?text='+encodeURIComponent(text); }

  /* ¿NO ENCUENTRAS TU AUTO? (JP 2026-09-14). El selector ya no lista versiones, modelos ni marcas
     sin ningun repuesto (regla "solo con producto" del fitment-api). Esas paginas traian el boton
     de cotizar por WhatsApp; para no perder ese contacto, cada lista termina con este boton y el
     auto ya escrito. `nivel`: 'marca' (portada), 'modelo' (pagina de marca), 'version' (modelo). */
  function waNoEncuentras(nivel, marca, modelo){
    var auto = [marca, modelo].filter(Boolean).join(' ');
    var titulo = nivel==='marca' ? '¿No encuentras la marca de tu auto?'
      : nivel==='modelo' ? '¿No encuentras tu modelo'+(marca?' '+marca:'')+'?'
      : '¿No encuentras tu versión?';
    var txt = nivel==='marca'
      ? 'Hola! Quiero cotizar un repuesto. La marca de mi auto no aparece en la página: '
      : 'Hola! Quiero cotizar un repuesto para mi '+auto+'. Mi '+(nivel==='modelo'?'modelo':'versión')+' no aparece en la página: ';
    return '<div class="al-consulta-box al-no-encuentras"><div class="al-consulta-h">'+ic('wa')+' '+esc(titulo)+'</div>'+
      '<p>Escríbenos y te cotizamos el repuesto igual.</p>'+
      '<a class="al-btn al-wa" target="_blank" rel="noopener" href="'+waLink(txt)+'">Cotízalo por WhatsApp</a></div>';
  }

  /* Logo del fabricante del repuesto en la esquina superior derecha de la foto (JP 2026-09-14).
     Los PNG viven en assets/marca-<slug>.png y Liquid entrega sus URLs en window.AL_LOGOS
     (snippet al-logos-marca). La marca llega escrita de muchas formas —vendor de Shopify
     ("Bosch"/"BOSCH", 8 líneas GTX) o mfr_name de TecDoc ("FEBI BILSTEIN")—: se normaliza a
     letras y números, y LOGO_ALIAS junta las que no coinciden con el slug. Sin logo → nada. */
  var LOGO_ALIAS = {FEBIBILSTEIN:'febi', TOYOTAORIGINAL:'toyota', TOYOTAGENUINE:'toyota', MAHLECLEVITE:'mahle',
    STANDARDMOTORPRODUCTS:'smp', GMORIGINAL:'gm', GENERALMOTORS:'gm', MAGNETIMARELLI:'magneti', MANNFILTER:'mann',
    STPCONTINENTAL:'stp', STPMITSUBOSHI:'stp', NISSANVALUEADVANTAGE:'nissan', NISSANGENUINE:'nissan', HYUNDAIMOBIS:'mobis'};
  function logoMarca(nombre){
    var L = window.AL_LOGOS;
    if(!L || !nombre) return '';
    var k = String(nombre).normalize('NFD').replace(/[̀-ͯ]/g,'').toUpperCase().replace(/[^A-Z0-9]/g,'');
    var s = /^GTX/.test(k) ? 'gtx' : (LOGO_ALIAS[k] || k.toLowerCase());
    return L[s] || '';
  }
  function logoHTML(nombre, cls){
    var u = logoMarca(nombre);
    return u ? '<img class="'+cls+'" src="'+esc(u)+'" alt="'+esc(nombre)+'" loading="lazy">' : '';
  }

  // Silueta neutra de auto (SVG inline) para cuando NO hay imagen de vehículo, o la URL del crawl
  // falla al cargar (token TecDoc expirado / 403). Así el selector NUNCA muestra una imagen rota.
  var CAR_SIL = '<svg class="al-veh-sil" viewBox="0 0 512 208" role="img" aria-label="Imagen de vehículo no disponible">'+
    '<path d="M40 150c-11 0-18-7-18-18v-8c0-9 6-15 15-17l52-10 48-40c9-8 21-12 33-12h96c17 0 33 8 43 22l26 38 58 12c17 4 29 15 29 30v13c0 11-7 18-18 18h-28a40 40 0 0 1-80 0h-104a40 40 0 0 1-80 0z"/>'+
    '<circle cx="150" cy="150" r="30"/><circle cx="366" cy="150" r="30"/>'+
    '<circle class="hub" cx="150" cy="150" r="13"/><circle class="hub" cx="366" cy="150" r="13"/></svg>';

  // Panel de foto del vehículo (derecha en desktop / arriba en móvil, estilo euroem). Una imagen por
  // MODELO/generación: el endpoint /vehiculo-imagen la resuelve por model_id. sin_imagen o fallo de
  // carga -> silueta neutra (nunca imagen rota).
  function vehFotoHtml(img, alt){
    if(!img || img.sin_imagen || !img.imagen){
      return '<div class="al-modelo-img">'+CAR_SIL+'<div class="al-modelo-cap">Imagen referencial no disponible</div></div>';
    }
    // La imagen se sirve desde el api (almacenamiento propio): ruta relativa -> anteponer base del api.
    var src = img.imagen.charAt(0)==='/' ? API + img.imagen : img.imagen;
    // Sin loading="lazy": es la imagen principal de la pantalla (above-the-fold), la queremos ya.
    return '<div class="al-modelo-img">'+
      '<img src="'+esc(src)+'" alt="'+esc(alt)+'" onerror="AL.vehImgFail(this)">'+
      '<div class="al-modelo-cap">Imagen referencial del modelo</div></div>';
  }

  /* DOS VISTAS, UN MODO (JP 2026-08-09). Por defecto el sitio es la tienda: el cliente ve
     los productos comprables y nada más. Con `?revision=1` en la URL de la página, la
     navegación entera pasa a la vista de trabajo de JP —fichas de maestro con número,
     identificador, OEMs, cobertura, avisos y estado de cotización— y el parámetro viaja a
     la API en cada consulta. Se lee UNA vez: el hash cambia al navegar, la query no. */
  /* Sin expresión regular a propósito: el minificador de Shopify convierte el `` de
     un literal /.../ en un backspace real, y la condición no calzaba nunca — la vista de
     revisión se veía igual que la de cliente y nada avisaba (medido 2026-08-09). */
  var REVISION = (function(){
    try{
      var v = new URLSearchParams(location.search).get('revision');
      return v !== null && ['1','true','si'].indexOf(String(v).toLowerCase()) >= 0;
    }catch(e){ return false; }
  })();

  /* ---------- LA TRACCIÓN DEL AUTO DEL CLIENTE (JP 2026-10-09 / 2026-10-11) ----------
     El selector lista una fila por cilindraje y combustible ("2.4" en vez de "2.4" y "2.4 4x4")
     y las piezas que dependen de la tracción llevan "Solo 4x4" / "Solo 4x2". Eso lo decide el
     interruptor del API, para toda la tienda: el tema no lo pide. Lo que hace el tema es guardar
     la tracción que trae la patente y mandarla en `traccion=`, para que el api no liste las
     piezas que son solo de la otra. */
  var TRACCION_PATENTE = true;
  // La tracción del auto del cliente, cuando la trae la patente. Vive en la pestaña, por vehículo.
  function tuLeer(){ try{ return JSON.parse(sessionStorage.getItem('al_traccion')||'{}') || {}; }catch(e){ return {}; } }
  function tuGuardar(lts, t){
    if(!TRACCION_PATENTE || (t!=='4x4' && t!=='4x2')) return;
    try{
      var d = tuLeer();
      (lts||[]).forEach(function(lt){ if(lt) d[lt] = t; });
      sessionStorage.setItem('al_traccion', JSON.stringify(d));
    }catch(e){}
  }
  function tuDe(lt){ return TRACCION_PATENTE ? (tuLeer()[lt] || null) : null; }
  function tuOlvidar(lt){
    try{ var d = tuLeer(); delete d[lt]; sessionStorage.setItem('al_traccion', JSON.stringify(d)); }catch(e){}
  }
  // ¿La fila junta versiones 4x2 y 4x4? Lo dice /vehiculo (versiones[].t4). Solo ahí tiene sentido
  // avisar que se escondieron las piezas de la otra tracción (JP 2026-10-12).
  function tuJunta(v){
    var hay4 = false, hay2 = false;
    ((v && v.versiones) || []).forEach(function(x){ if(x.t4 === true) hay4 = true; else if(x.t4 === false) hay2 = true; });
    return hay4 && hay2;
  }

  /* ---------- LA PATENTE DEL CLIENTE (JP 2026-10-12) ----------
     Vive en la pestaña, por vehículo, igual que la tracción. Con ella el api suma a la categoría
     Frenos los frenos que el proveedor declara para ESE auto (los vinculados se quedan: las dos
     listas se suman). Solo se manda en los vehículos a los que la patente llevó; el api además
     comprueba que la marca coincida. */
  function paLeer(){ try{ return JSON.parse(sessionStorage.getItem('al_patente')||'{}') || {}; }catch(e){ return {}; } }
  function paGuardar(q, lts, modelos, anio){
    try{
      var d = {q:q, lts:{}, modelos:{}};
      if(+anio >= 1950 && +anio <= 2100) d.anio = +anio;        // el año del auto (JP 2026-10-13)
      (lts||[]).forEach(function(lt){ if(lt) d.lts[lt] = 1; });
      (modelos||[]).forEach(function(m){ if(m) d.modelos[m] = 1; });
      sessionStorage.setItem('al_patente', JSON.stringify(d));
    }catch(e){}
  }
  function paDe(lt){ var d = paLeer(); return (d.q && d.lts && d.lts[lt]) ? d.q : null; }
  /* EL AÑO DEL AUTO (JP 2026-10-13). Lo trae la patente y viaja en `anio=`: con él, el api no
     lista las piezas cuyo vínculo no cubre ese año y calla el aviso "Aplica a modelos…" donde sí
     aplica. Vale para los mismos vehículos que la patente; "Ver todos" lo olvida en ese vehículo. */
  var ANIO_PATENTE = true;
  function anDe(lt){
    var d = paLeer();
    return (ANIO_PATENTE && d.q && d.anio && d.lts && d.lts[lt] && !(d.sin_anio && d.sin_anio[lt])) ? d.anio : null;
  }
  function anOlvidar(lt){
    try{
      var d = paLeer();
      d.sin_anio = d.sin_anio || {};
      d.sin_anio[lt] = 1;
      sessionStorage.setItem('al_patente', JSON.stringify(d));
    }catch(e){}
  }
  // La patente ofreció un MODELO (no una versión): las versiones de ese modelo la heredan.
  function paAdoptarModelo(modelId, lts){
    try{
      var d = paLeer();
      if(!d.q || !d.modelos || !d.modelos[modelId]) return;
      (lts||[]).forEach(function(lt){ if(lt) d.lts[lt] = 1; });
      sessionStorage.setItem('al_patente', JSON.stringify(d));
    }catch(e){}
  }
  // ¿Venía del recuadro de Frenos? Se lee una vez y se olvida.
  function paDestino(){
    try{ var x = sessionStorage.getItem('al_pat_destino'); sessionStorage.removeItem('al_pat_destino'); return x; }catch(e){ return null; }
  }
  function frenosPatenteCaja(lt){
    var q = paDe(lt);
    if(q) return '<div class="al-note al-tu-nota" style="margin-top:18px">Incluye los frenos para tu patente <b>'+esc(q)+'</b>.</div>';
    return '<form class="al-pat" style="margin-top:22px" onsubmit="return AL.patenteFrenos(this)" autocomplete="off">'+
      '<label class="al-pat-l" for="al-patf-in">Pon tu patente y te mostramos los frenos exactos de tu auto</label>'+
      '<div class="al-pat-fila">'+
        '<input id="al-patf-in" class="al-pat-in" name="patente" type="text" maxlength="8" '+
          'placeholder="EJ: GFBY98" aria-label="Patente" autocapitalize="characters" required>'+
        '<button class="al-pat-btn" type="submit">Ver mis frenos</button>'+
      '</div></form>';
  }

  function apiGet(path, params){
    if(TRACCION_PATENTE && params && params.linkage_target_id != null){
      var t0 = tuDe(params.linkage_target_id);
      if(t0){ var p2 = {}; for(var k0 in params) p2[k0] = params[k0]; p2.traccion = t0; params = p2; }
    }
    if(params && params.linkage_target_id != null && (path === '/categorias' || path === '/tipos' || path === '/piezas')){
      var pa0 = paDe(params.linkage_target_id);
      if(pa0){ var p3 = {}; for(var k1 in params) p3[k1] = params[k1]; p3.patente = pa0; params = p3; }
    }
    if(params && params.linkage_target_id != null && (path === '/vehiculo' || path === '/categorias' || path === '/tipos' || path === '/piezas')){
      var a0 = anDe(params.linkage_target_id);
      if(a0){ var p4 = {}; for(var k2 in params) p4[k2] = params[k2]; p4.anio = a0; params = p4; }
    }
    var qs = '';
    if(params){ var a=[]; for(var k in params){ if(params[k]!=null) a.push(enc(k)+'='+enc(params[k])); } qs='?'+a.join('&'); }
    var url = API + path + qs;
    if(MEM[url]) return Promise.resolve(MEM[url]);
    return fetch(url, {headers:{'Accept':'application/json'}}).then(function(r){
      if(!r.ok) throw new Error('api '+r.status);
      return r.json();
    }).then(function(j){ MEM[url]=j; return j; });
  }

  /* El ENCABEZADO ya no se pinta acá (JP 2026-09-08). Vive en snippets/al-header.liquid y lo
     renderiza el layout en todas las páginas: antes cada plantilla montaba #allure-app con
     distintos datos y el encabezado salía diferente en la ficha de producto. La lógica del
     menú y del buscador está en assets/allure-menu.js. */

  /* El interruptor de vista visible se quito el 2026-09-08 a pedido de JP: era la muleta
     para construir la pagina y en la tienda terminada solo hacia ruido sobre el buscador.
     La vista de revision SIGUE existiendo, solo que ahora se pide por URL: agregar
     `?revision=1` a la direccion (el hash se conserva, asi que se puede activar sin perder
     el vehiculo que se esta mirando). Para volver a la vista de cliente, se quita. */

  function shell(inner){
    app.innerHTML = '<div class="al-wrap">' + inner + '</div>';
    galeriaSwipe();
    /* el header se rehace entero: el contador del carro se vuelve a aplicar desde AlCart */
    if(window.AlCart) AlCart.syncBadge();
  }
  function loading(){ shell('<div class="al-loading">Cargando…</div>'); }

  // Devuelve el vehículo (cache CTX si coincide, si no lo pide al api)
  function vehiculoCtx(lt){
    if(CTX.vehiculo && CTX.lt===lt) return Promise.resolve(CTX.vehiculo);
    return apiGet('/vehiculo', {linkage_target_id:lt}).then(function(v){
      CTX = {manu_id:v.manu_id, marca:v.marca, model_id:v.model_id, modelo:v.modelo, lt:lt, vehiculo:v};
      return v;
    });
  }

  function route(){
    if(!API){ shell('<div class="al-note">Falta configurar la URL del fitment-api. En el editor de temas, sección <b>Allure TecDoc</b> → <b>URL fitment-api</b>.</div>'); return; }
    var h=(location.hash||'#home').slice(1); var p=h.split('/');
    var map={marca:'marca',modelo:'modelo',vehiculo:'vehiculo',cat:'cat',tipo:'tipo',ficha:'ficha',buscar:'buscar',frenos:'frenos',patente:'patente'};
    var view = map[p[0]] || 'home';
    document.body.setAttribute('data-view', view);
    loading();
    var run;
    if(view==='marca') run=viewMarca(+p[1]);
    else if(view==='modelo') run=viewModelo(+p[1]);
    else if(view==='vehiculo') run=viewVehiculo(+p[1]);
    else if(view==='cat') run=viewCategoria(+p[1], dec(p[2]));
    else if(view==='tipo') run=viewTipo(+p[1], dec(p[2]), +p[3]);
    else if(view==='ficha') run=viewFicha(dec(p.slice(1).join('/')));
    else if(view==='buscar') run=viewBusqueda(dec(p[1]));
    else if(view==='frenos') run=viewFrenos(dec(p[1]));
    else if(view==='patente') run=viewPatente(dec(p[1]));
    else run=viewHome();
    Promise.resolve(run).then(function(){ window.scrollTo(0,0); }).catch(function(e){
      shell('<div class="al-note">No pudimos cargar esta sección ('+esc(String(e.message||e))+'). Reintenta en un momento.</div>');
    });
  }

  /* ---------- HOME: banner editable + grilla de marcas ---------- */
  var MARCAS_HOME = ['DODGE','RAM','FORD','JEEP','CHEVROLET','PEUGEOT','CITROEN','KIA',
                     'HYUNDAI','TOYOTA','MAZDA','NISSAN',
                     'BMW','AUDI','MERCEDES-BENZ','VOLKSWAGEN','PORSCHE','MINI','SEAT','VOLVO',
                     'LAND ROVER','JAGUAR'];
  function viewHome(){
    return apiGet('/marcas').then(function(marcas){
      /* Solo estas marcas en la grilla del home, en este orden (JP 2026-09-28). Las demás
         siguen existiendo en el api y en sus enlaces #marca/<id>; solo no se listan aquí. */
      var orden = MARCAS_HOME.map(function(n){ return n.toUpperCase(); });
      marcas = marcas.filter(function(m){ return orden.indexOf(String(m.marca).toUpperCase()) >= 0; })
        .sort(function(a, b){ return orden.indexOf(String(a.marca).toUpperCase()) - orden.indexOf(String(b.marca).toUpperCase()); });
      var brands = marcas.map(function(m){
        // Logo real de la marca (TecDoc, servido desde el api propio). Si no carga
        // (api caído / marca sin logo), AL.brandImgFail vuelve a la inicial de siempre.
        // Sin loading="lazy": la grilla de marcas es la pantalla principal (above-the-fold).
        var logo = API
          ? '<img class="al-brand-img" src="'+esc(API+'/marca-logo?manu_id='+m.manu_id)+'"'+
            ' alt="'+esc(m.marca)+'" data-ini="'+esc(m.marca.charAt(0))+'"'+
            ' onerror="AL.brandImgFail(this)">'
          : esc(m.marca.charAt(0));
        return '<button class="al-brand" onclick="location.hash=\'#marca/'+m.manu_id+'\'">'+
          '<span class="al-brand-logo'+(API?' al-logo-img':'')+'" data-slug="'+slug(m.marca)+'">'+logo+'</span>'+
          '<span class="al-brand-name">'+esc(m.marca)+'</span></button>';
      }).join('');
      shell(
        '<div class="al-banner"><div class="al-banner-in"><span>'+esc(BANNER)+'</span>'+
          (BANNER_SUB?'<small>'+esc(BANNER_SUB)+'</small>':'')+'</div></div>'+
        '<div class="al-hero"><h1>'+esc(HERO_TITLE)+'</h1><p>'+esc(HERO_SUB)+'</p></div>'+
        patenteCajon()+
        '<div class="al-brands">'+brands+'</div>');
      /* Sin el botón «¿No encuentras la marca de tu auto?» bajo las marcas: JP lo sacó el
         2026-09-14. waNoEncuentras sigue al pie de las páginas de marca y de modelo. */
    });
  }

  /* ---------- BUSCADOR POR PATENTE de toda la tienda (JP 2026-10-09) ----------
     patente -> /patente del fitment-api -> la pagina de vehiculo que YA existe. No es una lista
     nueva: es entrar directo a la navegacion de siempre. El api decide entre una version (se
     entra sin preguntar), varias (se muestran para elegir) y fuera (mensaje + WhatsApp con la
     patente ya escrita: es una cotizacion para el vendedor).
     La consulta NO pasa por apiGet/MEM: una respuesta "espera" no puede quedar guardada como la
     respuesta de esa patente. */
  function patenteCajon(){
    return '<form class="al-pat" onsubmit="return AL.patente(this)" autocomplete="off">'+
      '<label class="al-pat-l" for="al-pat-in">¿No sabes cuál es tu versión? Busca tu auto por patente</label>'+
      '<div class="al-pat-fila">'+
        '<input id="al-pat-in" class="al-pat-in" name="patente" type="text" maxlength="8" '+
          'placeholder="EJ: GFBY98" aria-label="Patente" autocapitalize="characters" required>'+
        '<button class="al-pat-btn" type="submit">Buscar mi auto</button>'+
      '</div></form>';
  }
  function patLimpia(q){ return String(q||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function patAuto(v){
    if(!v) return '';
    return [v.marca, v.modelo, v.anio, v.cilindrada, v.combustible, v.traccion]
      .filter(Boolean).join(' ').replace(/\s+/g,' ').trim();
  }
  function patFuera(q, r){
    var v = r && r.vehiculo, auto = patAuto(v), m = (r && r.motivo) || '';
    var msg = 'No pudimos identificar tu auto en nuestro catálogo en línea.';
    if(r && r.estado === 'no_encontrada') msg = 'No encontramos la patente '+q+'. Revisa que esté bien escrita.';
    else if(m === 'marca_no_trabajada' || m === 'marca_sin_catalogo') msg = 'Todavía no tenemos catálogo en línea para '+((v && v.marca) || 'esa marca')+'.';
    else if(m.indexOf('anterior_a_') === 0) msg = 'En la tienda en línea trabajamos autos de '+m.slice(11)+' en adelante'+(v && v.anio ? ', y el tuyo es '+v.anio : '')+'.';
    else if(m === 'sin_repuestos') msg = 'Todavía no tenemos repuestos publicados para tu auto.';
    else if(m === 'sin_tu_motor') msg = 'Tenemos repuestos para tu modelo, pero todavía no para tu motor.';
    else if(m === 'alta_demanda') msg = 'Estamos con muchas consultas en este momento.';
    var txt = 'Hola! Quiero cotizar repuestos para mi auto, patente '+q+(auto ? ' ('+auto+')' : '')+'. ';
    return (auto ? '<div class="al-pat-auto">Tu auto: <b>'+esc(auto)+'</b></div>' : '')+
      '<div class="al-consulta-box"><div class="al-consulta-h">'+ic('wa')+' '+esc(msg)+'</div>'+
      '<p>Escríbenos y te lo cotizamos igual: ya va tu patente en el mensaje.</p>'+
      '<a class="al-btn al-wa" target="_blank" rel="noopener" href="'+waLink(txt)+'">Cotízalo por WhatsApp</a></div>'+
      // sin tu motor: la ficha de la patente se equivoca a veces; el modelo queda a un clic
      ((m === 'sin_tu_motor' && r.opciones && r.opciones.length) ? '<p class="al-pat-otra">¿No es ese tu motor? '+
        r.opciones.map(function(o){ return '<a href="#modelo/'+(+o.model_id)+'">Ver las versiones de '+esc(o.modelo)+'</a>'; }).join(' · ')+'</p>' : '')+
      ((r && r.estado === 'no_encontrada') ? '' : '<p class="al-pat-otra"><a href="#frenos/'+esc(q)+'">Ver los frenos para tu patente</a></p>')+
      '<p class="al-pat-otra"><a href="#home">Buscar por marca y modelo</a></p>';
  }
  function viewPatente(q, intento){
    q = patLimpia(q);
    var crumb = '<div class="al-crumb"><a href="#home">Inicio</a> › <b>Patente '+esc(q)+'</b></div>';
    if(q.length < 5 || q.length > 6){
      shell(crumb+'<div class="al-note">Escribe una patente válida, por ejemplo GFBY98.</div>'+patenteCajon());
      return Promise.resolve();
    }
    var aqui = function(){ return patLimpia(dec((location.hash||'').split('/')[1])) === q && (location.hash||'').indexOf('#patente/') === 0; };
    var url = API+'/patente?patente='+enc(q)+'&marcas='+enc(MARCAS_HOME.join(','));
    return fetch(url, {headers:{'Accept':'application/json'}}).then(function(resp){
      if(!resp.ok) throw new Error('api '+resp.status);
      return resp.json();
    }).then(function(r){
      if(!aqui()) return;                        // el cliente ya se fue a otra pagina
      if(r.estado === 'espera'){
        intento = intento || 0;
        if(intento >= 6){ shell(crumb+patFuera(q, {motivo:'alta_demanda'})); return; }
        shell(crumb+'<div class="al-loading">Buscando tu auto…</div>');
        var seg = Math.min(15, Math.max(3, +r.reintentar_en || 5));
        return new Promise(function(ok){ setTimeout(ok, seg*1000); })
          .then(function(){ if(aqui()) return viewPatente(q, intento+1); });
      }
      // la tracción que trae la patente vale para el auto, elija la fila que elija
      var trac = r.vehiculo && r.vehiculo.traccion;
      if(r.estado === 'una' && r.lt){
        tuGuardar([r.lt], trac); paGuardar(q, [r.lt], [], r.vehiculo && r.vehiculo.anio);
        // venía del recuadro de Frenos: vuelve a Frenos, ahora con los frenos de su patente
        location.replace(paDestino() === 'Frenos' ? '#cat/'+r.lt+'/Frenos' : '#vehiculo/'+r.lt); return;
      }
      paDestino();
      var ops = r.opciones || [];
      tuGuardar(ops.map(function(o){ return o.lt; }), trac);
      if((r.estado === 'una' || r.estado === 'varias') && ops.length){
        paGuardar(q, ops.map(function(o){ return o.lt; }), ops.map(function(o){ return o.tipo === 'modelo' ? o.model_id : null; }), r.vehiculo && r.vehiculo.anio);
      }
      if(r.estado === 'varias' && ops.length){
        var auto = patAuto(r.vehiculo);
        var esModelo = ops[0].tipo === 'modelo';
        var filas = ops.map(function(o){
          var href = o.tipo === 'modelo' ? '#modelo/'+o.model_id : '#vehiculo/'+o.lt;
          return '<a class="al-row" href="'+href+'"><span>'+esc(o.modelo+(o.version ? ' · '+o.version : ''))+'</span>'+
            '<span class="al-row-sub">'+esc(o.anios||'')+'</span></a>';
        }).join('');
        var titulo = ops.length === 1 ? '¿Es este tu auto?' : (esModelo ? 'Elige tu modelo' : 'Elige tu versión');
        var bajada = r.motivo === 'version_sin_confirmar' ? 'Encontramos tu auto, pero no pudimos confirmar la versión exacta.'
          : r.motivo === 'generacion_vecina' ? 'Tu auto puede ser de más de una generación: fíjate en los años.'
          : r.motivo === 'codigo_de_motor' ? 'Por el motor de tu auto, es una de estas versiones.'
          : 'Tu patente calza con más de una versión.';
        var txt = 'Hola! Quiero cotizar repuestos para mi auto, patente '+q+(auto ? ' ('+auto+')' : '')+'. Mi versión no aparece en la página. ';
        shell(crumb+
          (auto ? '<div class="al-pat-auto">Tu auto: <b>'+esc(auto)+'</b></div>' : '')+
          '<div class="al-h2">'+titulo+'</div><p class="al-pat-bajada">'+bajada+'</p>'+
          '<div class="al-list">'+filas+'</div>'+
          '<p class="al-pat-otra">¿Ninguna es tu auto? <a target="_blank" rel="noopener" href="'+waLink(txt)+'">Cotízalo por WhatsApp</a></p>');
        return;
      }
      shell(crumb+patFuera(q, r));
    });
  }

  /* ---------- MARCA → modelos ---------- */
  function viewMarca(manuId){
    return apiGet('/modelos', {manu_id:manuId}).then(function(modelos){
      var marca = modelos.length ? modelos[0].marca : '';
      CTX.manu_id=manuId; CTX.marca=marca;
      var lista = modelos.map(function(x){
        return '<a class="al-row" href="#modelo/'+x.model_id+'"><span>'+esc(x.modelo)+'</span>'+
          '<span class="al-row-sub">'+esc(x.anio_desde)+'–'+esc(x.anio_hasta||'')+'</span></a>';
      }).join('') || '<div class="al-note">Sin modelos para esta marca.</div>';
      // Logo real de la marca (mismo endpoint que la grilla del home), arriba a la derecha del
      // título. Si no carga (api caído / marca sin logo), AL.marcaLogoFail borra el panel entero:
      // aquí NO hay fallback a la inicial — el nombre de la marca ya está en el título.
      var logo = API
        ? '<div class="al-marca-logo"><img src="'+esc(API+'/marca-logo?manu_id='+manuId)+'"'+
          ' alt="'+esc(marca)+'" onerror="AL.marcaLogoFail(this)"></div>'
        : '';
      shell('<div class="al-crumb"><a href="#home">Inicio</a> › <b>'+esc(marca)+'</b></div>'+
        '<div class="al-marca-head"><div class="al-h2">Elige tu modelo '+esc(marca)+'</div>'+logo+'</div>'+
        '<div class="al-list">'+lista+'</div>');
      /* Sin el botón «¿No encuentras tu modelo…?» al pie de los modelos: JP lo sacó el 2026-09-15. */
    });
  }

  /* ---------- MODELO → versiones (con foto del vehículo, estilo euroem: 1 imagen por modelo) ---------- */
  function viewModelo(modelId){
    return apiGet('/motorizaciones', {model_id:modelId}).then(function(vers){
      var marca=vers.length?vers[0].marca:''; var modelo=vers.length?vers[0].modelo:''; var manu=vers.length?vers[0].manu_id:CTX.manu_id;
      CTX.manu_id=manu; CTX.marca=marca; CTX.model_id=modelId; CTX.modelo=modelo;
      paAdoptarModelo(modelId, vers.map(function(x){ return x.linkage_target_id; }));
      var lista = vers.map(function(x){
        return '<a class="al-row" href="#vehiculo/'+x.linkage_target_id+'"><span>'+esc(x.motorizacion)+'</span>'+
          '<span class="al-row-sub">'+esc(x.kw)+' kW · '+esc(x.hp)+' HP · '+esc(x.anio_desde)+'–'+esc(x.anio_hasta||'')+'</span></a>';
      }).join('') || '<div class="al-note">Sin versiones.</div>';
      // Foto del vehículo: 1 por modelo/generación (NO por versión). El endpoint la resuelve por
      // model_id; le pasamos cualquier linkage_target_id de la lista. Si no hay versiones, no la pedimos.
      // Si el endpoint falla, tratamos como sin_imagen -> silueta (nunca rompe la navegación).
      var imgProm = vers.length
        ? apiGet('/vehiculo-imagen', {linkage_target_id:vers[0].linkage_target_id}).catch(function(){ return {sin_imagen:true}; })
        : Promise.resolve({sin_imagen:true});
      return imgProm.then(function(img){
        shell('<div class="al-crumb"><a href="#home">Inicio</a> › <a href="#marca/'+manu+'">'+esc(marca)+'</a> › <b>'+esc(modelo)+'</b></div>'+
          '<div class="al-h2">'+esc(marca+' '+modelo)+' — elige la versión</div>'+
          '<div class="al-modelo">'+
            vehFotoHtml(img, marca+' '+modelo)+
            '<div class="al-modelo-list"><div class="al-list">'+lista+'</div></div>'+
            /* sin «¿No encuentras tu versión?» al pie de las versiones: JP lo sacó el 2026-09-15 */
          '</div>');
      });
    });
  }

  /* ---------- VEHÍCULO → categorías (estructura completa) + info ---------- */
  function viewVehiculo(lt){
    return Promise.all([apiGet('/vehiculo',{linkage_target_id:lt}), apiGet('/categorias',{linkage_target_id:lt})]).then(function(res){
      var v=res[0], cats=res[1];
      CTX={manu_id:v.manu_id, marca:v.marca, model_id:v.model_id, modelo:v.modelo, lt:lt, vehiculo:v};
      var grid = cats.map(function(c){
        return '<div class="al-col-card" onclick="location.hash=\'#cat/'+lt+'/'+enc(c.coleccion)+'\'">'+
          '<div class="n">'+esc(c.coleccion)+'</div><div class="bar"></div></div>';
      }).join('') || '<div class="al-note">Sin categorías para este vehículo.</div>';
      var info=[['Marca',v.marca],['Modelo',v.modelo],['Versión',v.motorizacion],
        ['Año',(v.anio_desde||'')+'–'+(v.anio_hasta||'')],['Combustible',v.combustible||'—'],
        ['Potencia',(v.kw||'')+' kW • '+(v.hp||'')+' HP'],['Códigos de motor',v.codigos_motor||'—']];
      shell('<div class="al-crumb"><a href="#home">Inicio</a> › <a href="#marca/'+v.manu_id+'">'+esc(v.marca)+'</a> › <a href="#modelo/'+v.model_id+'">'+esc(v.modelo)+'</a> › <b>'+esc(v.motorizacion)+'</b></div>'+
        '<div class="al-h2">Piezas para '+esc(v.marca+' '+v.modelo)+' • '+esc(v.motorizacion)+'</div>'+
        (tuDe(lt) && tuJunta(v) ? '<div class="al-note al-tu-nota">Según tu patente, tu auto es <b>'+tuDe(lt)+'</b>: no mostramos las piezas que son solo para '+(tuDe(lt)==='4x4' ? '4x2' : '4x4')+'. <a href="#" onclick="return AL.tuTodas('+(+lt)+');">Ver todas</a></div>' : '')+
        (v.anio_auto && v.anio_auto.escondidas > 0 ? '<div class="al-note al-tu-nota">Según tu patente, tu auto es del año <b>'+esc(v.anio_auto.anio)+'</b>: no mostramos los repuestos que no aplican a ese año. <a href="#" onclick="return AL.anTodos('+(+lt)+');">Ver todos</a></div>' : '')+
        '<div class="al-cols">'+grid+'</div>'+
        '<div class="al-h2">Información del vehículo</div>'+
        '<div class="al-veh">'+info.map(function(kv){return '<div class="kv"><span>'+esc(kv[0])+'</span><span>'+esc(kv[1])+'</span></div>';}).join('')+'</div>');
    });
  }

  /* ---------- CATEGORÍA → tipos de pieza (texto, sin conteos) ---------- */
  function viewCategoria(lt, col){
    return Promise.all([vehiculoCtx(lt), apiGet('/tipos',{linkage_target_id:lt, coleccion:col})]).then(function(res){
      var v=res[0], tipos=res[1];
      var lista = tipos.map(function(t){
        return '<a class="al-row" href="#tipo/'+lt+'/'+enc(col)+'/'+t.generic_article_id+'">'+
          '<span>'+esc(t.tipo)+'</span><span class="al-row-arr">›</span></a>';
      }).join('') || '<div class="al-note">Sin tipos de pieza para esta categoría.</div>';
      shell('<div class="al-crumb"><a href="#home">Inicio</a> › <a href="#vehiculo/'+lt+'">'+esc(v.marca+' '+v.modelo)+'</a> › <b>'+esc(col)+'</b></div>'+
        '<div class="al-h2">'+esc(col)+' — elige el tipo de pieza</div><div class="al-list">'+lista+'</div>'+
        (col === 'Frenos' ? frenosPatenteCaja(lt) : ''));
    });
  }

  /* ---------- TIPO → producto MAESTRO (números OEM del fabricante) + comprables ----------
     Regla OEM (JP 2026-07-22): ya no se listan las marcas aftermarket de TecDoc. Se muestra
     UNA ficha maestra del tipo x vehículo con los números de parte del FABRICANTE del vehículo
     (los únicos confiables para cotizar) + los productos comprables reales de la tienda. */
  function viewTipo(lt, col, gid){
    return Promise.all([vehiculoCtx(lt), apiGet('/piezas',{linkage_target_id:lt, coleccion:col, generic_article_id:gid, por_pagina:48, revision:(REVISION?1:null)})]).then(function(res){
      var v=res[0], data=res[1];
      var tipo = data.tipo || (data.propios ? 'Productos Allure' : (data.piezas.length ? data.piezas[0].generic_desc : ''));
      var m = data.maestro;
      var maestroHtml = '';
      if(m){
        var vehTxt = v.marca+' '+v.modelo+(v.motorizacion?' '+v.motorizacion:'');
        // Split posicional (JP): si el tipo tiene posiciones (bandejas/amortiguadores/discos...),
        // UNA tarjeta maestra por posición con SUS OEMs — no se mezclan izquierda/derecha ni ejes.
        /* g = un maestro. Del motor viene con nombre de venta, número corto y número de
           cotizar; calculado en vivo viene sólo con la posición y la lista de OEMs.
           NO va la lista de modelos: el cliente ya entró por su vehículo, y esa
           información es del informe de revisión (JP 2026-08-07). */
        /* Los OEM por lado, en segundo plano: sirven para ver que el par está completo
           sin que tapen lo que se decide. */
        var lados_html = function(g){
          var L = (g && g.lados) || {};
          var filas = [];
          ['izquierda','derecha','ambos'].forEach(function(k){
            if (L[k] && L[k].length) {
              filas.push('<div><span>'+k+'</span>'+esc(L[k].slice(0,6).join(', '))+
                (L[k].length > 6 ? ' … ('+L[k].length+')' : '')+'</div>');
            }
          });
          return filas.length ? '<div class="al-lados">'+filas.join('')+'</div>' : '';
        };
        /* SE COTIZA CON: en un tipo que se vende por eje son DOS números, uno por lado.
           El canónico solo es media respuesta y JP tiene que poder verificar las dos
           búsquedas antes de gastarlas. Si falta un lado se dice cuál — no se rellena. */
        var cotizar_html = function(g){
          var cp = g && g.cotizar_par;
          if (!cp || !cp.numeros || !cp.numeros.length) {
            return g && g.cotizar
              ? '<div class="al-cotizar"><span>SE COTIZA CON</span><b>'+esc(g.cotizar)+'</b></div>'
              : '';
          }
          var falta = (cp.forma === 'sin_espejo' || cp.forma === 'sin_lado');
          var nums = cp.numeros.map(function(x){
            var lado = x[0] ? '<i>'+esc(x[0])+'</i>' : '';
            return '<span>'+lado+'<b>'+esc(x[1])+'</b></span>';
          }).join('');
          return '<div class="al-cotizar'+(falta ? ' al-cotizar--falta' : '')+'">'+
              '<span class="al-cotizar-tit">SE COTIZA CON</span>'+nums+
              (cp.forma === 'sin_espejo'
                ? '<em>⚠ falta el lado '+esc(cp.falta)+': no se puede cotizar como par</em>' : '')+
              (cp.forma === 'sin_lado'
                ? '<em>⚠ TecDoc no declara lado: se busca el mismo número para los dos</em>' : '')+
              (cp.forma === 'par' && cp.por_consecutivo === false
                ? '<em>⚠ el espejo no es consecutivo: verificar</em>' : '')+
            '</div>';
        };
        var cardM = function(g, universal){
          var oems = (g && g.oems) || [];
          var posicion = g && g.posicion;
          /* Del motor el título ES el nombre de venta ("Par de Amortiguadores
             Delanteros · adaptativa"), que ya dice el tipo: anteponerle "Amortiguador —"
             lo repetiría. Sin nombre se arma como antes. */
          var titulo = (g && g.nombre) ? g.nombre : (tipo + (posicion ? ' — '+posicion : ''));
          /* EL número con que se cotiza, uno por maestro y sin cascada. Si no viene
             (cálculo en vivo), se cae a los primeros OEMs, como hasta ahora. */
          var ref = (g && g.cotizar) ? g.cotizar
            : (oems.length ? oems.slice(0,4).map(function(o){return o.numero;}).join(', ') : '');
          var waTxt = 'Hola! Quiero cotizar: '+titulo+' para '+vehTxt+(ref ? '. OEM ref: '+ref : '');
          /* Marca de origen: un par formado por el motor y un split calculado al vuelo no
             merecen la misma confianza, y hay que poder distinguirlos de un vistazo. */
          /* "sin verificar" es una marca de calidad INTERNA: distingue un maestro
             formado por el motor de un split calculado al vuelo. Al cliente no le dice
             nada y le siembra duda sobre una pieza que sí vendemos, así que solo se
             pinta en la vista de revisión (JP 2026-08-09). */
          var delMotor = (g && g.origen === 'motor') || !data.revision;
          /* La tarjeta es HOY la herramienta de revisión de JP, no la tienda del
             cliente: el tema está sin publicar y nadie más la ve. Así que trae todo lo
             que hace falta para juzgar si el maestro está bien construido ANTES de
             gastar una cotización. Cuando se publique de verdad se decide qué se recorta.
             NADA de esto se calcula aquí: el API lo lee de `maestro_revision`, que llena
             `tarjetas.tarjeta()` — la misma función que imprime el informe. */
          var g2 = g || {};
          var anios = g2.anio_min ? (g2.anio_min + '–' + (g2.anio_max || 'hoy')) : '';
          var compat = [];
          if (g2.n_modelos) compat.push('<b>' + g2.n_modelos + ' modelos</b>');
          /* "versiones", no "vehículos": la unidad de TecDoc es modelo x motor x años y
             sin decirlo el número no se entiende (340 no son 340 autos distintos). */
          if (g2.n_vehiculos) compat.push(g2.n_vehiculos +
            ' versiones <span class="al-nota">(modelo × motor × años)</span>');
          if (anios) compat.push(anios);
          /* `marcas_alcanzan` viene resuelto del motor: si el sitio lo recalculara,
             podria contradecir al informe de revisión, que es lo único que esta vista
             no se puede permitir. */
          var pocas = (g2.marcas_alcanzan === false);
          /* Las que no son oferta en este vehículo NO LLEGAN: el API ya las filtró.
             Esta es la lista de trabajo de JP, no una auditoría — el porqué de cada una
             queda en el informe de revisión (JP, 2026-08-08). */
          return '<div class="al-maestro' + (delMotor ? '' : ' al-maestro--vivo') + '">'+
            '<div class="al-maestro-head"><span class="badge">OEM '+esc(m.marca_vehiculo||v.marca)+'</span>'+
            (delMotor ? '' : '<span class="al-maestro-vivo">sin verificar</span>')+
            '<div class="al-maestro-tit">'+esc(titulo)+'</div></div>'+
            ((g2.etiqueta || g2.identificador)
              ? '<div class="al-maestro-ref">'+
                  (g2.etiqueta ? '<b>'+esc(g2.etiqueta)+'</b>' : '')+
                  (g2.identificador ? '<span>'+esc(g2.identificador)+'</span>' : '')+
                '</div>'
              : '')+
            cotizar_html(g2)+
            (compat.length
              ? '<div class="al-maestro-sub2">Compatible con '+compat.join(' · ')+'</div>'
              : '<div class="al-maestro-sub2">'+esc(vehTxt)+'</div>')+
            ((g2.modelos && g2.modelos.length)
              ? '<div class="al-modelos">'+g2.modelos.map(function(x){
                  return '<span>'+esc(x)+'</span>'; }).join('')+'</div>'
              : '')+
            /* ESTADO DE COTIZACIÓN (JP 2026-08-09). Lo primero que hay que saber al
               revisar: ¿este ya se cotizó y con qué salió, o está por hacer? Va arriba de
               todo, y las pendientes vienen primero en la lista (lo ordena la API). */
            (g2.estado_cotizacion
              ? '<div class="al-estado al-estado--'+esc(g2.estado_cotizacion)+'">'+
                  esc({pendiente:'PENDIENTE — sin cotizar',
                       ok:'COTIZADO',
                       sin_ofertas:'SIN OFERTAS — el proveedor no tiene esta pieza',
                       error:'ERROR AL COTIZAR'}[g2.estado_cotizacion]
                      || g2.estado_cotizacion)+
                  ((g2.productos_publicados && g2.productos_publicados.length)
                    ? '<div class="al-estado-prods">'+g2.productos_publicados.map(function(x){
                        return '<span>'+esc(x.marca)+' '+esc(x.mpn)+' · '+(clpInt(x.precio)||'')+'</span>';
                      }).join('')+'</div>'
                    : '')+
                  (g2.motivo_estado ? '<div class="al-estado-motivo">'+esc(g2.motivo_estado)+'</div>' : '')+
                '</div>'
              : '')+
            /* Los avisos suben ANTES de los números: son lo que decide si este maestro
               se cotiza o se aparta, y en una revisión de cientos no pueden quedar al
               final de una lista larga. */
            ((g2.avisos && g2.avisos.length)
              ? '<div class="al-avisos">'+g2.avisos.map(function(x){
                  return '<div class="al-aviso">⚠ '+esc(x)+'</div>'; }).join('')+'</div>'
              : '')+
            (g2.productos
              ? '<div class="al-maestro-nace'+(pocas ? ' al-alerta' : '')+'">'+
                  (pocas ? '⚠ ' : '')+
                  'De este maestro nacen <b>'+g2.productos+' productos</b>, uno por marca'+
                  (g2.veredicto_marcas ? ' — '+esc(g2.veredicto_marcas) : '')+
                '</div>'
              : '')+
            (oems.length
              ? '<div class="al-maestro-sub">Números de parte originales '+esc(m.marca_vehiculo||v.marca)+':</div>'+
                /* Los lados van a la vista: son lo que dice si el par está completo.
                   La lista plana los REPITE, así que va plegada — con cientos de tarjetas
                   que revisar, treinta chips por tarjeta son tres pantallas de scroll
                   para ver lo mismo dos veces. */
                lados_html(g2)+
                '<details class="al-oems-det"><summary>'+oems.length+
                  ' números en total</summary>'+
                  '<div class="al-maestro-oems">'+oems.map(function(o){
                    return '<span class="al-chip">'+esc(o.numero)+'</span>'; }).join('')+
                '</div></details>'
              : (universal
                ? '<div class="al-maestro-sub">Esta pieza se elige por especificación (tipo, medida o norma), no por número de parte. Cotízala directo para tu vehículo:</div>'
                : '<div class="al-maestro-sub">Cotizamos esta pieza para tu vehículo con nuestros proveedores.</div>'))+
            '<a class="al-maestro-wa" target="_blank" rel="noopener" href="'+waLink(waTxt)+'">Cotizar por WhatsApp</a>'+
          '</div>';
        };
        /* >= 1, no > 1: un maestro del motor con su nombre y su número también es una
           tarjeta maestra. Con `> 1` un tipo con un solo maestro caía a la lista cruda
           de OEMs del vehículo y perdía el nombre. */
        if(m.maestros && m.maestros.length >= 1){
          maestroHtml = m.maestros.map(function(g){ return cardM(g, false); }).join('');
        } else {
          maestroHtml = cardM({oems: m.oems||[]}, m.universal);
        }
      }
      var cards = data.piezas.map(function(p){ return cardPieza(p); }).join('');
      var comprablesHtml = cards
        ? '<div class="al-maestro-sub" style="margin-top:14px">Disponible ahora en Allure:</div><div class="al-lista">'+cards+'</div>'
        : '';
      if(!maestroHtml && !comprablesHtml) maestroHtml = '<div class="al-note">Sin piezas para este tipo.</div>';
      shell('<div class="al-crumb"><a href="#home">Inicio</a> › <a href="#vehiculo/'+lt+'">'+esc(v.marca+' '+v.modelo)+'</a> › <a href="#cat/'+lt+'/'+enc(col)+'">'+esc(col)+'</a> › <b>'+esc(tipo)+'</b></div>'+
        '<div class="al-h2">'+esc(tipo)+
          (m && m.n_no_aplican ? '<span class="al-conteo">'+m.n_visibles+
            ' opciones · '+m.n_no_aplican+' no aplican</span>' : '')+
        '</div>'+comprablesHtml+maestroHtml);
      hidratarFilas();
    });
  }

  /* ---------- LISTADO VERTICAL estilo Mercado Libre (JP 2026-07-29) ----------
     Antes: grilla de tarjetas de 2/3/4 columnas. Ahora: UNA fila por producto — imagen a la
     izquierda, datos a la derecha — y el cliente navega deslizando hacia abajo. Toda la fila
     es clickeable (el CTA es un <a>, por eso el contenedor es <article>, no un anchor). */

  // miniatura: imagen REAL de Shopify si la API la trae; si no, placeholder.
  // (img chica del proveedor: max-width, nunca width/height 100% — no se pixela)
  // onerror: la URL puede apuntar al CDN de Shopify y quedar muerta si esa foto se borra o
  // cambia en la tienda; el api la entrega igual (ORDER BY idx LIMIT 1, sin validar). Degradar
  // al mismo placeholder es preferible al ícono de imagen rota. El onerror reemplaza SOLO la foto
  // (outerHTML), así la etiqueta que va en la misma caja no se pierde.
  // Sin logo de marca en el listado (JP 2026-09-15, reversa del 2026-09-14): aquí va solo la foto
  // original para que la lista se vea limpia; el logo queda únicamente en la galería de la ficha.
  function thumbHtml(img, alt, marca, badge){
    var extra = badge || '';
    var cls = 'al-item-media';
    return img
      ? '<div class="'+cls+'"><img class="al-item-foto" src="'+esc(img)+'" alt="'+esc(alt||'')+'" loading="lazy"'
        + ' onerror="this.outerHTML=\'<span class=&quot;al-item-ph&quot;>Sin imagen</span>\'">'+extra+'</div>'
      : '<div class="'+cls+'"><span class="al-item-ph">Sin imagen</span>'+extra+'</div>';
  }

  // Los títulos del catálogo siguen el molde "Pieza · Variante · MARCA MPN — Vehículos".
  // En el listado solo se usa nombre + marca: el número de parte y las compatibilidades los ve el
  // cliente al entrar a la página de producto (JP 2026-07-29 — aquí solo ocupaban espacio).
  function parseTitulo(t){
    var out = {nombre:String(t||''), ref:'', marca:'', veh:''};
    var i = out.nombre.indexOf(' — ');
    if(i > 0){ out.veh = out.nombre.slice(i+3); out.nombre = out.nombre.slice(0, i); }
    var segs = out.nombre.split(' · ');
    if(segs.length > 1){ out.ref = segs[segs.length-1]; out.nombre = segs.slice(0,-1).join(' · '); }
    out.marca = marcaDe(out.ref);
    return out;
  }
  // "MAGNETI MARELLI 357461070000" -> "MAGNETI MARELLI". El número de parte siempre trae dígitos;
  // la marca puede ser de varias palabras ("Magnum Technology"), así que se corta en el primer token
  // con dígito. Si la marca misma llevara dígitos, cae al primer token en vez de quedar vacía.
  function marcaDe(ref){
    var toks = String(ref||'').trim().split(/\s+/), out = [];
    for(var i=0;i<toks.length;i++){
      if(/\d/.test(toks[i]) || toks[i]==='+') break;
      out.push(toks[i]);
    }
    // Un solo token con dígitos ("· N205042", molde Euroespecialista) es solo el número de parte, no
    // marca: se devuelve vacío y hidratarFilas() pone el vendor del producto ("TISS").
    return out.join(' ') || (toks.length > 1 ? toks[0] : '');
  }
  // precio de la api: entero en pesos (NO centavos como el /products/{handle}.js de Shopify)
  function clpInt(n){
    var x = Number(String(n==null?'':n).replace(/[^0-9.]/g,''));
    if(!isFinite(x) || x <= 0) return null;
    try { return '$'+Math.round(x).toLocaleString('es-CL'); } catch(e){ return '$'+Math.round(x); }
  }

  /* OFERTA (JP 2026-09-18) — el precio de lista tachado y el % de descuento.
     `antes` y `precio` van en PESOS (no en centavos). Devuelve null si no hay precio de
     lista o si no es mayor que el precio de venta: un "descuento" de 0% o negativo no se
     anuncia. El numero NUNCA se calcula acá — sale de compare_at_price de Shopify. */
  function ofertaDe(precio, antes){
    var p = Number(precio), a = Number(antes);
    if(!isFinite(p) || !isFinite(a) || p <= 0 || a <= p) return null;
    /* El monto en PESOS es lo que el cliente entiende sin calcular: "$6.095" responde
       cuanto me guardo, "13%" obliga a hacer la cuenta. El % se conserva entre parentesis.
       (JP 2026-09-19) */
    return {antes: clpInt(a), pct: Math.round((a - p) / a * 100), monto: clpInt(a - p)};
  }
  function pesos(cents){                      // los JSON de Shopify vienen en centavos
    var n = Number(cents);
    return isFinite(n) ? Math.round(n / 100) : null;
  }

  /* Condiciones comerciales de la fila (JP 2026-08-06).
     El monto se deriva del precio YA formateado por clpInt ("$28.990"; "$28990" en el fallback):
     el peso chileno no lleva decimales, así que quitar todo lo que no sea dígito devuelve los
     pesos exactos. Se hace acá y no en cada llamador para que las tres vistas que arman filas
     (catálogo por vehículo, búsqueda por OEM, frenos por patente) muestren lo mismo sin tocar
     sus firmas. */
  var ENVIO_GRATIS_DESDE = 100000;   // pesos; el envío va gratis desde este monto inclusive
  var CUOTAS = 6;                    // cuotas sin interés de Mercado Pago (listado y ficha leen de acá)
  function montoDe(precioTxt){
    var n = parseInt(String(precioTxt == null ? '' : precioTxt).replace(/\D/g, ''), 10);
    return isFinite(n) ? n : 0;
  }

  /* Fila única del listado. o = {dest, handle, imagen, badge, nombre, marca, precio, comprable}
     Sin botón de compra: nadie compra desde el listado (JP) — la fila entera lleva al producto y
     la flecha de la derecha es la única señal de que es navegable.
     Si falta imagen o marca, la fila queda marcada con data-handle y la completa hidratarFilas(). */
  function itemRow(o){
    var of = o.oferta;
    var precio = o.precio
      ? (of ? '<div class="al-item-antes">'+esc(of.antes)+'</div>' : '')+
        '<div class="al-item-precio">'+esc(o.precio)+
          (of ? ' <span class="al-item-dcto">Ahorras '+esc(of.monto)+' <i>('+of.pct+'%)</i></span>' : '')+'</div>'
      : '';
    var marca  = o.marca ? '<div class="al-item-tags"><span class="al-item-tag">'+esc(o.marca)+'</span></div>' : '';
    // o.chip: etiqueta extra junto a la marca (la búsqueda marca el año, JP 2026-09-16)
    if(o.chip) marca = marca ? marca.replace('</div>', o.chip+'</div>') : '<div class="al-item-tags">'+o.chip+'</div>';
    var aviso  = o.aviso ? '<div class="al-item-aviso">'+esc(o.aviso)+'</div>' : '';
    var estado = o.comprable
      ? '<div class="al-item-estado">Disponible</div>'
      : '<div class="al-item-estado consulta">Cotizar</div>';
    // Cuotas sólo donde hay precio: en las filas "Cotizar" no hay monto que financiar todavía.
    var mpLogo = MP_IMG ? '<img class="al-item-mp" src="'+esc(MP_IMG)+'" alt="Mercado Pago" loading="lazy">' : '';
    var cuotas = o.precio
      ? '<div class="al-item-cuotas">'+mpLogo+'<span>Hasta en '+CUOTAS+' cuotas sin interés</span></div>' : '';
    var envio  = montoDe(o.precio) >= ENVIO_GRATIS_DESDE
      ? '<div class="al-item-envio">Envío gratis</div>' : '';
    // En móvil todo se apila; en pantalla ancha el CSS manda el bloque de precio a la derecha
    // (si no, queda un hueco enorme donde antes estaba el botón).
    var falta = o.handle && (!o.imagen || !o.marca || !of) ? ' data-handle="'+esc(o.handle)+'"' : '';
    return '<article class="al-item"'+falta+' onclick="'+o.dest+'">'+
      // Etiqueta "Allure" eliminada (JP 2026-09-14): la esquina superior izquierda es del logo de la
      // marca. La "OEM" se mantiene, dentro de la foto y abajo (ver .al-item-media .al-item-badge).
      thumbHtml(o.imagen, o.nombre, o.marca,
        (o.badge && o.badge !== 'Allure') ? '<span class="al-item-badge">'+esc(o.badge)+'</span>' : '')+
      '<div class="al-item-info">'+
        '<div class="al-item-txt"><h3 class="al-item-name">'+esc(o.nombre)+'</h3>'+marca+aviso+'</div>'+
        '<div class="al-item-pr">'+precio+cuotas+envio+estado+'</div>'+
      '</div>'+
      '<span class="al-item-arr" aria-hidden="true">›</span>'+
    '</article>';
  }

  /* ---------- Relleno desde Shopify de lo que la api no trae ----------
     El índice del buscador (shopify_sync en el VPS) quedó atrás respecto a la tienda: en muchas
     categorías `imagen` viene null aunque el producto SÍ tenga fotos publicadas (medido 2026-07-29:
     58 de 81 comprables del BMW F21). Y el chip de marca solo se puede sacar del título cuando éste
     trae el separador " · ", cosa que no todas las categorías cumplen.
     Para que TODO el catálogo se vea igual, cada fila incompleta pide su producto real a Shopify
     (`/products/{handle}.js`, público) y se completa sola: imagen destacada + `vendor` como marca.
     De a 6 en paralelo, con cache, y solo para las filas que lo necesitan. */
  function prodJs(handle){
    var k = 'prod:'+handle;
    if(MEM[k] !== undefined) return Promise.resolve(MEM[k]);
    return fetch('/products/'+enc(handle)+'.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ MEM[k] = j; return j; });
  }
  function completarFila(el, prod){
    if(!prod) return;
    var media = el.querySelector('.al-item-media');
    var img = prod.featured_image || (prod.images && prod.images[0]);
    if(img && media && !media.querySelector('.al-item-foto')){
      var ph = media.querySelector('.al-item-ph');
      if(ph) ph.parentNode.removeChild(ph);
      media.insertAdjacentHTML('afterbegin', '<img class="al-item-foto" src="'+esc(img)+'" alt="'+esc(prod.title||'')+'" loading="lazy">');
    }
    var vend = prod.vendor || '';
    // "Allure Repuestos" es la tienda, no la marca de la pieza: en ese caso no se pone chip.
    if(vend && !/allure/i.test(vend) && !el.querySelector('.al-item-tag')){
      var txt = el.querySelector('.al-item-txt');
      if(txt) txt.insertAdjacentHTML('beforeend',
        '<div class="al-item-tags"><span class="al-item-tag">'+esc(vend)+'</span></div>');
    }
  }
  /* El precio de lista lo dice la TIENDA, no la tabla de la navegacion: la api solo sirve
     `precio`. Por eso la fila se completa con /products/{handle}.js, la misma llamada que ya
     trae imagen y marca (y que queda en memoria por handle). */
  function completarOferta(el, prod){
    var pr = el.querySelector('.al-item-precio');
    if(!pr || el.querySelector('.al-item-antes')) return;
    var v0 = (prod.variants && prod.variants[0]) || {};
    var of = ofertaDe(pesos(prod.price != null ? prod.price : v0.price),
                      pesos(v0.compare_at_price != null ? v0.compare_at_price : prod.compare_at_price));
    if(!of) return;
    pr.insertAdjacentHTML('beforebegin', '<div class="al-item-antes">'+esc(of.antes)+'</div>');
    pr.insertAdjacentHTML('beforeend', ' <span class="al-item-dcto">Ahorras '+esc(of.monto)+
      ' <i>('+of.pct+'%)</i></span>');
  }
  function hidratarFilas(){
    var pend = [].slice.call(document.querySelectorAll('.al-item[data-handle]'));
    if(!pend.length) return;
    var i = 0;
    function siguiente(){
      if(i >= pend.length) return;
      var el = pend[i++], h = el.getAttribute('data-handle');
      el.removeAttribute('data-handle');                       // no reintentar la misma fila
      prodJs(h).then(function(prod){ completarFila(el, prod); completarOferta(el, prod); })
        .catch(function(){})                                   // sin producto → queda como está
        .then(siguiente);
    }
    for(var k=0; k<Math.min(6, pend.length); k++) siguiente();
  }

  function cardPieza(p){
    // Producto PROPIO de Allure (resuelto por ficha): va directo a su página de producto.
    if(p.es_propio){
      var url = p.handle ? '/products/'+p.handle : '#';
      var t = parseTitulo(p.titulo || p.generic_desc || 'Producto Allure');
      return itemRow({
        dest: 'location.href=\''+url+'\'', handle: p.handle, imagen: p.imagen, badge: 'Allure',
        nombre: t.nombre, marca: t.marca, precio: clpInt(p.precio), comprable: true,
        // a que version del grupo aplica y desde/hasta que anio (fitment-api, JP 2026-10-02)
        aviso: [p.aviso_version, p.aviso_anios].filter(Boolean).join(' · ')
      });
    }
    // Pieza TecDoc: comprable si hay producto ACTIVE en Shopify; si no, va a su ficha informativa.
    // Acá el número SÍ va en el nombre: es lo único que distingue una pieza TecDoc de otra.
    var comprable = !!(p.tiene_producto && p.handle);
    return itemRow({
      dest: comprable ? 'location.href=\'/products/'+p.handle+'\'' : 'location.hash=\'#ficha/'+enc(p.article_key)+'\'',
      handle: comprable ? p.handle : '', imagen: p.imagen, badge: 'OEM',
      nombre: ((p.generic_desc||'')+' '+(p.article_number||'')).trim(),
      marca: p.mfr_name||'', precio: clpInt(p.precio), comprable: comprable
    });
  }

  /* ---------- FICHA: producto REAL de Shopify (imagen/precio/título/desc) + TecDoc como COMPLEMENTO ---------- */
  function viewFicha(key){
    // lt del contexto de navegación: el api pone ese vehículo (y su marca) PRIMERO en compatibilidad
    return apiGet('/pieza',{article_key:key, lt: CTX.lt || null}).then(function(p){
      if(!p || p.error){ shell('<div class="al-note">Pieza no encontrada.</div>'); return; }
      // Si es comprable (producto ACTIVE), traemos el producto REAL de Shopify para imagen/precio/título/descripción.
      var prom = (p.tiene_producto && p.handle)
        ? fetch('/products/'+p.handle+'.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; })
        : Promise.resolve(null);
      return prom.then(function(prod){ renderFicha(p, prod); });
    });
  }
  function clp(c){ try{ return '$'+Number(Math.round(c/100)).toLocaleString('es-CL'); }catch(e){ return '$'+Math.round(c/100); } }
  function vehChips(p){
    return (p.vehiculos_compatibles||[]).slice(0,40).map(function(x){
      return '<span class="al-chip">'+esc((x.marca+' '+x.modelo+' '+x.motorizacion).replace(/\s+/g,' ').trim())+'</span>';
    }).join(' ') || '<span class="grp">—</span>';
  }
  /* GALERÍA (JP 2026-09-08) — mismo diseño que el tema publicado: foto sin recuadro,
     fundido entre fotos, deslizamiento con el dedo y puntos rojos abajo. Se pinta una sola
     vez acá y la usan tanto la ficha del buscador como /products/{handle}. */
  function galeriaHTML(imgs, titulo, vacioNota, marca){
    imgs = (imgs || []).filter(Boolean);
    var logo = logoHTML(marca, 'al-gal-logo');
    var galCls = 'al-gal' + (logo ? ' al-con-logo' : '');
    if(!imgs.length){
      return '<div class="'+galCls+'"><div class="al-gal-vacio"><b>Sin imagen</b>' +
        (vacioNota ? '<small>' + esc(vacioNota) + '</small>' : '') + '</div>' + logo + '</div>';
    }
    var flecha = function(dir){
      var d = (dir === 'prev') ? 'm15 5-6 7 6 7' : 'm9 5 6 7-6 7';
      return '<button type="button" class="al-gal-nav al-gal-nav--' + dir + '" aria-label="' +
        (dir === 'prev' ? 'Foto anterior' : 'Foto siguiente') + '" onclick="AL.gal(this,' +
        (dir === 'prev' ? -1 : 1) + ')">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg></button>';
    };
    var slides = imgs.map(function(src, i){
      return '<div class="al-gal-slide' + (i === 0 ? ' on' : '') + '">' +
        '<img class="al-gal-img" src="' + esc(src) + '" alt="' + esc(titulo || '') + '"' +
        (i === 0 ? '' : ' loading="lazy"') + '></div>';
    }).join('');
    var dots = imgs.length > 1
      ? '<div class="al-gal-dots">' + imgs.map(function(_, i){
          return '<button type="button" class="al-gal-dot' + (i === 0 ? ' on' : '') +
            '" aria-label="Ver foto ' + (i + 1) + '" onclick="AL.gal(this,' + i + ',true)"></button>';
        }).join('') + '</div>'
      : '';
    /* Miniaturas: dicen de un vistazo cuántas fotos hay y dejan saltar a una sin deslizar.
       Sin recuadro: la activa se marca con el borde rojo, las demás con borde transparente. */
    var thumbs = imgs.length > 1
      ? '<div class="al-gal-thumbs">' + imgs.map(function(src, i){
          return '<button type="button" class="al-gal-thumb' + (i === 0 ? ' on' : '') +
            '" aria-label="Ver foto ' + (i + 1) + '" onclick="AL.gal(this,' + i + ',true)">' +
            '<img src="' + esc(src) + '" alt="" loading="lazy"></button>';
        }).join('') + '</div>'
      : '';
    return '<div class="'+galCls+'">' +
        '<div class="al-gal-main">' + slides +
          (imgs.length > 1 ? flecha('prev') + flecha('next') : '') + logo +
        '</div>' + dots + thumbs +
      '</div>';
  }

  /* Deslizar con el dedo. Se engancha al contenedor recién pintado (el molde se rehace en
     cada navegación), con el mismo umbral que usa el tema publicado. */
  function galeriaSwipe(){
    var main = app.querySelector('.al-gal-main');
    if(!main || main.dataset.swipe) return;
    main.dataset.swipe = '1';
    var x0 = 0, y0 = 0, swipe = false, UMBRAL = 40;
    main.addEventListener('touchstart', function(e){
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; swipe = false;
    }, {passive:true});
    main.addEventListener('touchmove', function(e){
      var dx = Math.abs(e.touches[0].clientX - x0), dy = Math.abs(e.touches[0].clientY - y0);
      if(dx > dy && dx > 10) swipe = true;
    }, {passive:true});
    main.addEventListener('touchend', function(e){
      if(!swipe) return;
      var dx = e.changedTouches[0].clientX - x0;
      if(Math.abs(dx) < UMBRAL){ swipe = false; return; }
      AL.gal(main, dx < 0 ? 1 : -1);
    }, {passive:true});
  }

  // ===================== MOLDE ÚNICO =====================
  // moldHTML(m) es el ÚNICO render de página de producto. Lo usan TANTO la ficha del buscador (TecDoc)
  // COMO la página /products/{handle} (Shopify). Cada bloque aparece sólo si hay dato real.
  // Modelo m: {crumbLabel, crumbVeh:{lt,marca,modelo}|null, imagenes:[], titulo, idrows:[[k,v]],
  //            precio:string|null, cta:{kind:'comprar'|'consultar', variantId, available, waMsg},
  //            descripcion:html|null, criterios:[[k,v]], oems:[[mfr,[num]]], compat:[{marca,modelo,motorizacion}], compatNote}
  function moldHTML(m){
    /* el verificador compara contra esto; se guarda al pintar, no se re-consulta */
    VERIF = {compat: m.compat || [], titulo: m.titulo || ''};
    var media = galeriaHTML(m.imagenes, m.titulo, null, m.marca);
    var idtab = (m.idrows && m.idrows.length)
      ? '<div class="al-idtab">'+m.idrows.map(function(r){return '<div class="kv"><span>'+esc(r[0])+'</span><span>'+esc(r[1])+'</span></div>';}).join('')+'</div>' : '';
    var qtybtns = '<div class="al-qty">'+
      '<button type="button" onclick="var i=this.parentNode.querySelector(\'input\');i.value=Math.max(1,(parseInt(i.value,10)||1)-1)">−</button>'+
      '<input value="1" inputmode="numeric" name="quantity">'+
      '<button type="button" onclick="var i=this.parentNode.querySelector(\'input\');i.value=(parseInt(i.value,10)||1)+1">+</button></div>';
    var cta;
    if(m.cta && m.cta.kind==='comprar'){
      var of = m.oferta;
      var precio = m.precio
        ? '<div class="al-price">'+esc(m.precio)+
            (of ? '<s class="al-price-antes">'+esc(of.antes)+'</s>'+
                  '<span class="al-price-dcto">Ahorras '+esc(of.monto)+
                  ' <i>('+of.pct+'%)</i></span>' : '')+
          '</div>'
        : '';
      var dis = (m.cta.available===false) ? ' disabled' : '';
      var lbl = (m.cta.available===false) ? 'Agotado' : 'Comprar';
      var lblHTML = (m.cta.available===false) ? esc(lbl) : ('<span class="al-ic">'+ic('cart')+'</span>'+esc(lbl));
      cta = precio +
        '<form action="/cart/add" method="post" onsubmit="return AlCart.add(this)">'+
          '<input type="hidden" name="id" value="'+esc(m.cta.variantId)+'">'+
          '<div class="al-qtybar">'+qtybtns+'<button type="submit" class="al-btn al-buy"'+dis+'>'+lblHTML+'</button></div>'+
        '</form>'+ pagosHTML() + cuotasHTML(m.precio) +
        ((m.entrega && m.cta.available!==false) ? entregaHTML(m.entrega) : '');
    } else {
      var wmsg = (m.cta && m.cta.waMsg) ? m.cta.waMsg : ('Hola, me interesa: '+m.titulo+'. ¿Disponibilidad y precio?');
      cta = '<div class="al-consulta-box"><div class="al-consulta-h">'+ic('wa')+' ¿Te interesa esta pieza?</div>'+
        '<p>Todavía no está publicada en la tienda. Escríbenos y te confirmamos <b>disponibilidad y precio</b> al instante — te la conseguimos.</p>'+
        '<a class="al-btn al-wa" target="_blank" rel="noopener" href="'+waLink(wmsg)+'">Consúltanos por WhatsApp</a></div>';
    }
    var crumb = m.crumbVeh
      ? '<div class="al-crumb"><a href="'+HP+'#home">Inicio</a> › <a href="'+HP+'#vehiculo/'+m.crumbVeh.lt+'">'+esc(m.crumbVeh.marca+' '+m.crumbVeh.modelo)+'</a> › <b>'+esc(m.crumbLabel)+'</b></div>'
      : '<div class="al-crumb"><a href="'+HP+'#home">Inicio</a> › <b>'+esc(m.crumbLabel)+'</b></div>';
    var desc = m.descripcion ? '<div class="al-h2">Descripción</div><div class="al-desc">'+m.descripcion+'</div>' : '';
    var crit = (m.criterios && m.criterios.length)
      ? '<div class="al-h2">Criterios técnicos</div><div class="al-spec al-spec-2col">'+m.criterios.map(function(c){return '<div class="kv"><span>'+esc(c[0])+'</span><span>'+esc(c[1])+'</span></div>';}).join('')+'</div>' : '';
    var oem = (m.oems && m.oems.length)
      ? '<div class="al-h2">Números OEM (Fabricante Original de Equipos)</div><div class="al-spec">'+m.oems.map(function(o){return '<div class="al-oemgrp">'+esc(o[0])+'</div>'+o[1].map(function(n){return '<span class="al-tag">'+esc(n)+'</span>';}).join('');}).join('')+'</div>' : '';
    /* FICHA PROPIA (JP 2026-09-15): su compatibilidad ya sale en "Se utiliza en los siguientes
       vehiculos" con el dato del proveedor; este bloque la duplicaba. Solo no se pinta. */
    var compat = (m.compat && m.compat.length && !m.ocultarCompat)
      ? '<div class="al-h2">Compatible con estos vehículos <small style="font-weight:400;color:#888">'+esc(m.compatNote||'')+'</small></div><div class="al-spec">'+m.compat.slice(0,60).map(function(x){return '<span class="al-chip">'+esc((x.marca+' '+(x.modelo||'')+' '+(x.motorizacion||'')).replace(/\s+/g,' ').trim())+'</span>';}).join(' ')+'</div>' : '';
    return crumb +
      '<div class="al-pdp"><div class="al-pdp-media">'+media+'</div>'+
      '<div class="al-pdp-buy">'+ratingHTML()+'<h1>'+esc(m.titulo)+'</h1>'+idtab+sellosHTML()+cta+verificadorHTML()+'</div></div>'+
      desc+crit+oem+compat;
  }

  // Confianza dentro de la COLUMNA DE COMPRA (decisión JP 2026-07-16, actualizada 2026-09-08):
  // orden exacto = sellos de confianza → precio → botón → medios de pago (imagen, la emite
  //                pagosHTML dentro del cta) → verificador de patente.
  // Vive aquí (y no en el snippet/sección Liquid) porque la buy-box la arma este molde; la versión
  // Liquid queda oculta por CSS (.al-sec-confianza) para no duplicar. Markup/clases idénticas
  // a snippets/al-producto-extra.liquid para reusar la misma CSS.
  // Medios de pago: una sola imagen (antes eran chips de texto). Se emite JUSTO DEBAJO del boton
  // de compra (decision JP 2026-09-07), no dentro del bloque de confianza. Debajo de esa barra
  // va el bloque de cuotas con el valor de cada una (cuotasHTML, decision JP 2026-09-08).
  function pagosHTML(){
    if(!PAGOS_IMG) return '';
    return '<div class="al-pagos-img"><img src="'+esc(PAGOS_IMG)+'" alt="Medios de pago: Visa, Mastercard, Webpay, Mercado Pago, Venti, Flow" loading="lazy"></div>';
  }
  /* Cuotas bajo la barra de medios de pago (JP 2026-09-08). Muestra el valor de CADA cuota y no
     solo que "hay cuotas": el monto dividido es lo que responde ¿me alcanza?. El precio se toma
     del que ya pintó el molde (montoDe lo pasa a pesos), así vale igual para el producto Shopify
     y para la pieza TecDoc, y nunca puede quedar desfasado del precio que se ve arriba.
     Sin bajada "pagando con Mercado Pago" (JP 2026-09-08): las 6 cuotas sin interés aplican a
     CUALQUIER tarjeta de crédito, así que amarrarlas a un medio de pago dejaba fuera al resto. */
  function cuotasHTML(precioTxt){
    var monto = montoDe(precioTxt);
    if(!monto) return '';                      // sin precio no hay cuota que calcular
    var cuota = clpInt(monto / CUOTAS);
    if(!cuota) return '';
    var logo = MP_IMG ? '<img class="al-cuotas-logo" src="'+esc(MP_IMG)+'" alt="Mercado Pago" loading="lazy">' : '';
    return '<div class="al-cuotas">'+logo+
        '<div class="al-cuotas-txt"><b>Hasta '+CUOTAS+' cuotas sin interés de '+esc(cuota)+'</b></div>'+
      '</div>';
  }

  /* Plazo de entrega con Correos de Chile (JP 2026-09-15, "modelo A" de la propuesta).
     Va bajo las cuotas y solo en los productos que Liquid marca con `entrega` ("3-5": Italfrenos,
     Alsacia y Mundo Repuestos). Las fechas son reales y se calculan al pintar: el día 1 es el día
     hábil SIGUIENTE a la compra y se saltan sábados, domingos y feriados — así un 15 de septiembre
     no promete llegar en Fiestas Patrias. FERIADOS_CL hay que extenderlo cada año. */
  var FERIADOS_CL = {
    '2026-09-18':1,'2026-09-19':1,'2026-10-12':1,'2026-10-31':1,'2026-11-01':1,'2026-12-08':1,'2026-12-25':1,
    '2027-01-01':1,'2027-03-26':1,'2027-03-27':1,'2027-05-01':1,'2027-05-21':1,'2027-06-21':1,'2027-06-28':1,
    '2027-07-16':1,'2027-08-15':1,'2027-09-17':1,'2027-09-18':1,'2027-09-19':1,'2027-10-11':1,'2027-10-31':1,
    '2027-11-01':1,'2027-12-08':1,'2027-12-25':1
  };
  var DIAS_L = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var DIAS_C = ['dom','lun','mar','mié','jue','vie','sáb'];
  var MESES_L = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var MESES_C = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function diaHabil(d){
    var k = d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    return d.getDay() !== 0 && d.getDay() !== 6 && !FERIADOS_CL[k];
  }
  function sumarHabiles(desde, n){
    var d = new Date(desde), c = 0;
    while(c < n){ d.setDate(d.getDate()+1); if(diaHabil(d)) c++; }
    return d;
  }
  // Íconos de trazo: toman el color del texto; rojo = lo que ya pasó, verde = la entrega.
  var ENT_SVG = {
    compra:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="32" height="22" rx="3.5"/><path d="M5 18h32M10 26h8"/><circle cx="35" cy="33" r="8" fill="#E30613" stroke="#E30613"/><path d="M31.5 33l2.5 2.5 4.5-5" stroke="#fff"/></svg>',
    caja:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 15l17-8 17 8v18l-17 8-17-8z"/><path d="M7 15l17 8 17-8M24 23v18"/><path d="M15.5 11l17 8v6" stroke="#E30613"/></svg>',
    camion:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 13h26v19H3z" fill="#fff"/><path d="M29 19h8l7 7.5V32H29z" fill="#fff"/><path d="M32 20.5v5.5h8"/><path d="M6 21h19M6 25h13" stroke="#E30613"/><circle cx="11" cy="33.5" r="4" fill="#fff"/><circle cx="36" cy="33.5" r="4" fill="#fff"/></svg>',
    casa:'<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 22L24 7l19 15"/><path d="M10 18.5V41h28V18.5"/><path d="M17 41V29h9v12"/><rect x="29" y="33" width="7" height="8" rx="1" stroke="#0a8a3f"/><path d="M29 36h7" stroke="#0a8a3f"/></svg>'
  };
  function entregaHTML(rango){
    var p = String(rango || '').split('-');
    var dmin = parseInt(p[0], 10), dmax = parseInt(p[1] || p[0], 10);
    if(!(dmin > 0) || !(dmax >= dmin)) return '';
    var hoy = new Date(); hoy.setHours(0,0,0,0);
    var d1 = sumarHabiles(hoy, 1), dA = sumarHabiles(hoy, dmin), dB = sumarHabiles(hoy, dmax);
    var mismoMes = dA.getMonth() === dB.getMonth();
    var rangoCorto = mismoMes
      ? dA.getDate()+' – '+dB.getDate()+' '+MESES_C[dB.getMonth()]
      : dA.getDate()+' '+MESES_C[dA.getMonth()]+' – '+dB.getDate()+' '+MESES_C[dB.getMonth()];
    var desde = DIAS_L[dA.getDay()]+' '+dA.getDate()+(mismoMes ? '' : ' de '+MESES_L[dA.getMonth()]);
    var hasta = DIAS_L[dB.getDay()]+' '+dB.getDate()+' de '+MESES_L[dB.getMonth()];
    function paso(cls, ico, dia, txt){
      return '<li class="al-ent-paso'+cls+'"><span class="al-ent-ico">'+ico+'</span>'+
        '<span class="al-ent-dia">'+dia+'</span><span class="al-ent-txt">'+txt+'</span></li>';
    }
    var logo = CORREOS_IMG
      ? '<img class="al-ent-correos" src="'+esc(CORREOS_IMG)+'" alt="Correos de Chile" loading="lazy">'
      : '<b>Correos de Chile</b>';
    return '<div class="al-entrega">'+
        '<div class="al-ent-top">'+
          '<div class="al-ent-tit">Llega a tu casa en <em>'+dmin+' a '+dmax+' días hábiles</em></div>'+
          '<div class="al-ent-sub">Si compras hoy, lo recibes entre el <b>'+desde+'</b> y el <b>'+hasta+'</b>.</div>'+
        '</div>'+
        '<ol class="al-ent-pasos">'+
          paso(' hecho', ENT_SVG.compra, 'Hoy', 'Compras')+
          paso('', ENT_SVG.caja, DIAS_C[d1.getDay()]+' '+d1.getDate(), 'Preparamos tu pedido')+
          paso(' ruta', ENT_SVG.camion, 'En ruta', 'Viaja con Correos')+
          paso(' final', ENT_SVG.casa, rangoCorto, 'En tu domicilio')+
        '</ol>'+
        '<div class="al-ent-pie">'+logo+'<span><b>Tu repuesto llega seguro a tu puerta.</b> Con seguimiento en cada etapa.</span></div>'+
      '</div>';
  }
  /* Sellos de la columna de compra (JP 2026-09-08): la garantía reemplaza a “Compra segura”
     y la calidad OEM a “Pago encriptado” — los medios de pago ya se muestran con su barra
     de logos justo debajo del botón, así que decirlo otra vez no agregaba nada. */
  var SELLOS = [['shield','Garantía de 6 meses'],['oem','Calidad OEM'],['truck','Despacho a todo Chile']];
  /* VERIFICADOR DE COMPATIBILIDAD (JP 2026-09-08).
     Antes era UI honesta pero ciega: escribieras lo que escribieras, derivaba a WhatsApp.
     Ahora resuelve de verdad: la patente (o el chasis) va al servicio del VPS
     —/frenos-patente, el mismo que ya usa el buscador de frenos de la home, que por dentro
     consulta el ws del proveedor y getapi.cl— y devuelve marca/modelo/año/versión. Con eso se
     compara contra la compatibilidad PUBLICADA de esta pieza, que ya está en el molde.

     Tres respuestas posibles, nunca una cuarta inventada:
       ok    -> el vehículo está en la lista de esta pieza
       duda  -> la lista no alcanza para decidir (falta el año, o la pieza no publica lista)
       no    -> la pieza es de otra marca/modelo
     El "no" NUNCA cierra la venta: siempre ofrece WhatsApp con la patente y la pieza cargadas,
     porque la lista publicada está incompleta en parte del catálogo y un falso negativo costaría
     una venta real. */
  var VERIF = {compat: [], titulo: ''};

  /* Estrellas sobre el título de la ficha. RECONSTRUIDA el 2026-09-08: la versión original se
     perdió al reescribir el bloque de confianza, y se rehízo calcando las clases que ya estaban
     en la CSS (.al-rating / .al-rating-stars / .al-rating-est / .al-rating-txt). El texto es
     prueba social de la TIENDA (lo fijó JP), no una calificación de esta pieza. */
  function ratingHTML(){
    var estrella = '<span class="al-rating-est"><svg viewBox="0 0 24 24"><path d="m12 2.6 2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9L12 2.6Z"/></svg></span>';
    return '<div class="al-rating">'+
        '<span class="al-rating-stars" aria-hidden="true">'+ estrella + estrella + estrella + estrella + estrella +'</span>'+
        '<span class="al-rating-txt">Más de 2.000 clientes confían en nosotros</span>'+
      '</div>';
  }

  function verificadorHTML(){
    return '<div class="al-verif">'+
        '<div class="al-verif-head"><span class="al-ic">'+ic('car')+'</span>'+
          '<div><b>¿Es compatible con tu vehículo?</b>'+
          '<small>Escribe tu patente y te lo confirmamos al instante.</small></div>'+
        '</div>'+
        '<div class="al-verif-tabs" role="tablist">'+
          '<button type="button" class="al-verif-tab on" data-modo="patente" onclick="AL.verifModo(this,\'patente\')">Patente</button>'+
          '<button type="button" class="al-verif-tab" data-modo="vin" onclick="AL.verifModo(this,\'vin\')">N.° de chasis</button>'+
        '</div>'+
        '<form class="al-verif-form" onsubmit="return AL.verificar(event)">'+
          '<input id="al-patente" maxlength="8" placeholder="EJ: GFBY98" aria-label="Patente" autocomplete="off">'+
          '<button type="submit" class="al-btn" id="al-verif-btn">Verificar</button>'+
        '</form>'+
        '<p class="al-verif-note" id="al-verif-note">Ingresa la patente de tu vehículo (sin guión).</p>'+
        '<div id="al-verif-res" class="al-verif-res" hidden></div>'+
      '</div>';
  }

  /* Los sellos salieron del bloque de confianza y ahora van ARRIBA DEL PRECIO
     (decisión JP 2026-09-08): el cliente lee compra segura / pago encriptado / despacho
     antes de ver el monto, no después de haber decidido. */
  function sellosHTML(){
    return '<div class="al-pagos">'+
        '<div class="al-sellos">'+SELLOS.map(function(s){
            return '<div class="al-sello"><span class="al-ic">'+ic(s[0])+'</span>'+esc(s[1])+'</div>';
          }).join('')+'</div>'+
      '</div>';
  }

  // Adaptador TecDoc (ficha del buscador): construye el modelo desde la pieza TecDoc (+ producto si lo hay) y renderiza el molde.
  function renderFicha(p, prod){
    var v = CTX.vehiculo || (p.vehiculos_compatibles && p.vehiculos_compatibles[0]) || {};
    var crumbVeh = v.linkage_target_id ? {lt:v.linkage_target_id, marca:v.marca, modelo:v.modelo} : null;
    var m;
    if(prod){
      var vendor = prod.vendor||'', sku=(prod.variants&&prod.variants[0]&&prod.variants[0].sku)||'';
      var idrows=[]; if(vendor && !/allure/i.test(vendor)) idrows.push(['Marca',vendor]); if(sku) idrows.push(['Código (SKU)',sku]);
      m = { crumbLabel:prod.title, crumbVeh:crumbVeh, imagenes:prod.images||[], titulo:prod.title, idrows:idrows, marca:vendor,
            precio:(prod.price!=null?clp(prod.price):null),
            oferta:ofertaDe(pesos(prod.price),
                            pesos((prod.variants&&prod.variants[0]&&prod.variants[0].compare_at_price)!=null
                                  ? prod.variants[0].compare_at_price : prod.compare_at_price)),
            cta:{kind:'comprar', variantId:(prod.variants&&prod.variants[0]&&prod.variants[0].id), available:(prod.available!==false)},
            descripcion:prod.description||null, criterios:[], oems:[],
            compat:((p.compat_ok!==false)?(p.vehiculos_compatibles||[]):[]), compatNote:'— datos TecDoc' };
    } else {
      var tecTitulo=(p.mfr_name?p.mfr_name+' ':'')+(p.generic_desc||'')+' '+(p.article_number||'');
      var vehTxt = v.marca ? (v.marca+' '+(v.modelo||'')+' '+(v.motorizacion||'')).replace(/\s+/g,' ').trim() : '';
      var idrows2=[['Número de pieza',p.article_number],['Fabricante',p.mfr_name||'—'],['Tipo de pieza',p.generic_desc||''],['EAN',p.ean||'no disponible']];
      var crit=(p.criterios||[]).map(function(c){return [c.criteriaDescription||c.criteriaAbbrDescription||'—', c.formattedValue||c.rawValue||''];});
      var byMfr={}; (p.oem_numbers||[]).forEach(function(o){var k=o.mfrName||o.mfrId||'OEM';(byMfr[k]=byMfr[k]||[]).push(o.articleNumber);});
      var oems=Object.keys(byMfr).map(function(k){return [k, byMfr[k]];});
      m = { crumbLabel:p.article_number, crumbVeh:crumbVeh, imagenes:[], titulo:tecTitulo, idrows:idrows2, marca:p.mfr_name||'',
            precio:null, cta:{kind:'consultar', waMsg:('Hola, me interesa: '+tecTitulo+(vehTxt?' para '+vehTxt:'')+'. ¿Disponibilidad y precio?')},
            descripcion:null, criterios:crit, oems:oems, compat:(p.vehiculos_compatibles||[]), compatNote:'— datos TecDoc' };
    }
    shell(moldHTML(m));
  }

  // Adaptador Shopify (página /products/{handle}): construye el modelo desde el producto real y renderiza el MISMO molde.

  /* ---------- RELACIONADOS EN LA FICHA (JP 2026-09-19) ----------
     DOS bloques separados, no uno mezclado, y cada uno con su propia regla:

       "Tambien te puede servir"           piezas complementarias, las que se cambian
                                           junto a la que se esta mirando
       "El mismo repuesto en otras marcas" el mismo numero original, otra marca de
                                           repuesto, ordenado de menor a mayor precio

     Los dos salen de /relacionados, que los calcula SOLO desde el producto que se ve:
     no usa patente, ni el vehiculo del verificador, ni nada del cliente.

     Se pintan DESPUES de la ficha, appendeando: si la api falla o tarda, la ficha
     queda exactamente como esta hoy. Un bloque que no llega a su piso no se muestra
     — el api ya lo devuelve vacio — y NUNCA se rellena con cualquier cosa. */
  function relFila(o){
    /* el MISMO molde de la navegacion y la busqueda: cero clases nuevas */
    return itemRow({
      dest: 'location.href=\'/products/'+enc(o.handle)+'\'',
      handle: o.handle, imagen: o.imagen || '', badge: 'Allure',
      nombre: o.titulo || '', marca: o.marca || '',
      precio: clpInt(o.precio), comprable: true
    });
  }
  function relBloque(titulo, items){
    if(!items || !items.length) return '';
    /* Rejilla 2x2 que se desliza (JP 2026-09-19). Las tarjetas son las MISMAS de
       siempre: lo que cambia es el layout, y lo cambia el CSS de .al-rel-pista. */
    return '<div class="al-h2">'+esc(titulo)+'</div>'+
           '<div class="al-rel-car">'+
             '<button type="button" class="al-rel-nav prev" aria-label="Anterior">\u2039</button>'+
             '<div class="al-rel-pista">'+items.map(relFila).join('')+'</div>'+
             '<button type="button" class="al-rel-nav next" aria-label="Siguiente">\u203a</button>'+
             '<div class="al-rel-puntos"></div>'+
           '</div>';
  }
  /* Flechas, puntos y el salto de pantalla. Una pantalla = el ancho visible de la
     pista, asi que el mismo codigo sirve con 2, 3 o 4 columnas sin saber cual es. */
  function relCarrusel(raiz){
    [].slice.call(raiz.querySelectorAll('.al-rel-car')).forEach(function(car){
      var pista = car.querySelector('.al-rel-pista');
      var puntos = car.querySelector('.al-rel-puntos');
      var prev = car.querySelector('.al-rel-nav.prev');
      var next = car.querySelector('.al-rel-nav.next');
      /* Se cuenta por COLUMNAS, no por scrollWidth/clientWidth: los gap y el padding
         inflan el scrollWidth y 4 columnas en 2 pantallas daban 3 (medido: 2W+14
         sobre W = 2,03 -> ceil 3). Con el paso real de una tarjeta el numero es
         exacto y ademas sirve con 2, 3 o 4 columnas sin saber cual es. */
      function paso(){
        var card = pista.querySelector('.al-item');
        if(!card) return 0;
        var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function cols(){
        var p = paso();
        return p ? Math.max(1, Math.round(pista.clientWidth / p)) : 1;
      }
      /* Cuantas filas tiene la rejilla lo dice el CSS, no una constante: el bloque
         paso de dos filas a una el mismo dia, y un 2 escrito a mano aca habria
         dejado el conteo de pantallas al doble sin que nada avisara. */
      function filas(){
        var f = getComputedStyle(pista).gridTemplateRows;
        return Math.max(1, (f || '').split(' ').filter(Boolean).length);
      }
      function nPag(){
        var total = Math.ceil(pista.querySelectorAll('.al-item').length / filas());
        return Math.max(1, Math.ceil(total / cols()));
      }
      function pagActual(){
        var ancho = cols() * paso();
        return ancho ? Math.round(pista.scrollLeft / ancho) : 0;
      }
      function pintar(){
        var n = nPag(), act = Math.min(pagActual(), n - 1);
        /* Todo cabe: ni flechas ni puntos. Un control que no lleva a ninguna parte
           es peor que no tenerlo. */
        car.classList.toggle('al-rel-una', n <= 1);
        if(puntos.childNodes.length !== n){
          puntos.innerHTML = '';
          for(var i = 0; i < n; i++){
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'al-rel-punto';
            b.setAttribute('aria-label', 'Pantalla ' + (i + 1));
            b.dataset.i = i;
            puntos.appendChild(b);
          }
        }
        [].slice.call(puntos.children).forEach(function(b, i){
          b.classList.toggle('on', i === act);
        });
        prev.disabled = act <= 0;
        next.disabled = act >= n - 1;
      }
      function ir(d){ pista.scrollBy({left: d * cols() * paso(), behavior: 'smooth'}); }
      prev.addEventListener('click', function(){ ir(-1); });
      next.addEventListener('click', function(){ ir(1); });
      puntos.addEventListener('click', function(e){
        var b = e.target.closest && e.target.closest('.al-rel-punto');
        if(b) pista.scrollTo({left: b.dataset.i * cols() * paso(), behavior: 'smooth'});
      });
      var t;
      pista.addEventListener('scroll', function(){
        clearTimeout(t); t = setTimeout(pintar, 60);
      }, {passive: true});
      window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(pintar, 120); });
      pintar();
      /* Las fotos llegan despues (hidratarFilas): cuando cambian, el ancho puede
         cambiar y el numero de pantallas con el. */
      setTimeout(pintar, 1200);
    });
  }
  function relacionados(pid){
    if(!pid) return;
    apiGet('/relacionados',{product_id:pid}).then(function(r){
      if(!r) return;
      var html = relBloque('También te puede servir', r.complementarias) +
                 relBloque('El mismo repuesto en otras marcas', r.hermanos_oem);
      if(!html) return;
      var wrap = app.querySelector('.al-wrap');
      if(!wrap) return;
      var caja = document.createElement('div');
      caja.className = 'al-relacionados';
      caja.innerHTML = html;
      wrap.appendChild(caja);
      relCarrusel(caja);
      /* completa imagen y marca de las filas que la api no trae, igual que el listado */
      hidratarFilas();
    }).catch(function(){ /* sin bloque; la ficha ya esta pintada */ });
  }

  function renderProducto(P){
    /* Compatibilidad desde los tags. Se cruzan TODAS las marcas con TODOS los modelos
       publicados (P.veh_marcas / P.veh_modelos): un repuesto suele servir a varios vehículos y
       quedarse con el último tag hacía que el verificador dijera "no corresponde" a un auto que
       sí estaba publicado. Si no hay listas, cae al par suelto de siempre. */
    function compatFromTags(veh){
      var marcas = (P.veh_marcas || []).filter(Boolean);
      var modelos = (P.veh_modelos || []).filter(Boolean);
      var yr = (veh && veh.desde) ? (' '+veh.desde+((veh.hasta && veh.hasta!==veh.desde)?'-'+veh.hasta:'')) : '';
      if(marcas.length && modelos.length){
        var out = [];
        marcas.forEach(function(ma){
          modelos.forEach(function(mo){
            out.push({marca:(ma+' '+mo+yr).toUpperCase(), modelo:'', motorizacion:''});
          });
        });
        return out.slice(0, 60);
      }
      if(veh && veh.marca){ return [{marca:(veh.marca+' '+(veh.modelo||'')+yr).toUpperCase(), modelo:'', motorizacion:''}]; }
      return [];
    }
    function build(compat){
      var idrows=[]; if(P.vendor && !/allure/i.test(P.vendor)) idrows.push(['Marca',P.vendor]); if(P.sku) idrows.push(['Código (SKU)',P.sku]);
      var m = { crumbLabel:P.title, crumbVeh:null, imagenes:P.images||[], titulo:P.title, idrows:idrows, marca:P.vendor||'',
                precio:(P.price!=null?clp(P.price):null),
                oferta:ofertaDe(pesos(P.price), pesos(P.compare_at_price)),
                cta:{kind:'comprar', variantId:P.variant_id, available:(P.available!==false)},
                descripcion:P.description||null, criterios:[], oems:[], compat:compat||[], compatNote:'— datos TecDoc',
                ocultarCompat:(P.ficha_propia===true), entrega:(P.entrega||'') };
      shell(moldHTML(m));
      relacionados(P.id);
    }
    if(P.article_key){
      apiGet('/pieza',{article_key:P.article_key}).then(function(p){ build((p&&p.vehiculos_compatibles)||compatFromTags(P.veh)); }).catch(function(){ build(compatFromTags(P.veh)); });
    } else { build(compatFromTags(P.veh)); }
  }

  /* ---------- BÚSQUEDA (JP 2026-09-16) ----------
     La caja del encabezado ya no llega acá: va a /search, la página de resultados de Shopify.
     #buscar/<texto> se conserva solo para no romper enlaces guardados y redirige. La consulta
     estricta la arma allure-menu.js (ALMenu.urlBusqueda): un solo lugar. */
  function urlBusqueda(texto, extra){
    if(window.ALMenu && ALMenu.urlBusqueda) return ALMenu.urlBusqueda(texto) + (extra || '');
    return '/search?type=product&q=' + enc(texto) + (extra || '');
  }
  function viewBusqueda(qy){
    qy = (qy || '').trim();
    if(!qy){ location.replace('/#home'); return new Promise(function(){}); }
    location.replace(urlBusqueda(qy));
    return new Promise(function(){});           // la página se va: no pintar nada entremedio
  }

  /* ---------- PÁGINA DE RESULTADOS /search ----------
     Liquid (sections/allure-busqueda.liquid) entrega los resultados de Shopify en
     window.ALLURE_SEARCH y acá se pintan con el MISMO itemRow() de la navegación.

     Palabras (JP 2026-09-16):
       1. búsqueda ESTRICTA: todas las palabras, en título o tag (la arma allure-menu.js).
       2. si da 0 —error de tipeo, palabra rara— o la sintaxis deja de filtrar: búsqueda
          normal de Shopify con un aviso (al_modo=normal). Sin vocabulario de correcciones.
       3. año: ordena y marca ("Calza con 2015"), no descarta.
       4. "También podría interesarte", solo en la última página: suelta palabras de la PIEZA,
          nunca la del auto. Medido: soltar el auto trae amortiguadores de Captiva a quien
          busca un Rio.
     Números de parte:
       1. productos de la tienda (búsqueda normal: el OEM vive en la descripción)
       2. PUENTE de OEM si da 0: el fitment devuelve cómo está escrito ese número y se va a la
          forma que tenga productos. Medido: 230402F930 → 23040-2F930, 2 productos.
       3. fichas TecDoc + WhatsApp si sigue en 0. Nunca cuando hay productos. */
  var BQ_ORIG = 'al_orig';                    // número tal como lo escribió el cliente, tras el puente
  var BQ_MAX_FORMAS = 6;
  var BQ_MAX_TAMBIEN = 8;
  var BQ_PARAMS = ['al_q', 'al_anio', 'al_modo', 'al_orig'];   // Shopify los borra de sus enlaces

  function normNum(s){ return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function pareceNumero(s){
    var t = String(s || '').trim();
    if(!t || !/\d/.test(t)) return false;
    return normNum(t).length >= 5 && t.split(/\s+/).length <= 3;
  }
  function paramUrl(nombre){
    try{ return new URLSearchParams(location.search).get(nombre); }catch(e){ return null; }
  }
  // Los enlaces que arma Shopify (filtros, páginas, limpiar) pierden al_*: se los devuelve.
  function conAl(url){
    if(!url) return url;
    try{
      var u = new URL(url, location.origin), act = new URLSearchParams(location.search);
      BQ_PARAMS.forEach(function(k){ if(act.get(k) && !u.searchParams.get(k)) u.searchParams.set(k, act.get(k)); });
      return u.pathname + u.search;
    }catch(e){ return url; }
  }

  /* --- palabras de la consulta estricta ---
     Se leen de la propia q: "(title:delantero OR tag:delantero OR title:delantera …) AND (…)".
     Cada grupo es una palabra con sus variantes. */
  function bqGrupos(q){
    var out = [];
    String(q || '').replace(/\(([^)]*)\)/g, function(_, g){
      var v = [];
      g.replace(/title:([^\s)]+)/g, function(__, w){ if(v.indexOf(w) < 0) v.push(w); });
      if(v.length) out.push(v);
    });
    return out;
  }
  function bqTokens(s){
    var t = String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    return t.split(/[^a-z0-9.]+/).filter(Boolean);
  }
  // ¿la palabra (alguna variante) está entre los tokens? Singular y plural valen igual.
  function bqCalza(grupo, tokens){
    for(var i = 0; i < grupo.length; i++){
      var v = grupo[i];
      for(var k = 0; k < tokens.length; k++){
        var t = tokens[k];
        if(t === v || t === v + 's' || t === v + 'es' || v === t + 's' || v === t + 'es') return true;
      }
    }
    return false;
  }
  function bqTodas(grupos, tokens){
    return grupos.every(function(g){ return bqCalza(g, tokens); });
  }
  function bqTokensItem(it){
    return bqTokens((it.title || '') + ' ' + (it.type || '') + ' ' + (it.vt || it.tags || []).join(' '));
  }

  /* --- año: marca y orden, nunca descarte ---
     Los títulos multi-vehículo traen un rango por auto ("Hilux … 2015-2026 / Montero … 2008-2015").
     Solo cuentan los tramos del título que nombran el auto buscado. */
  function bqAnio(it, grupos, anio){
    var y = parseInt(anio, 10);
    if(!y) return '';
    var tipo = bqTokens(it.type), vt = bqTokens((it.vt || []).join(' '));
    var delAuto = grupos.filter(function(g){ return !bqCalza(g, tipo) && bqCalza(g, vt); });
    var noPieza = grupos.filter(function(g){ return !bqCalza(g, tipo); });
    var tramos = String(it.title || '').split(' / ');
    function tramosCon(gs){
      return tramos.filter(function(s){ var t = bqTokens(s); return gs.some(function(g){ return bqCalza(g, t); }); });
    }
    var rel = delAuto.length ? tramosCon(delAuto) : [];
    if(!rel.length && noPieza.length) rel = tramosCon(noPieza);
    if(!rel.length) rel = tramos;
    var txt = rel.join(' / '), hay = false, calza = false;
    txt = txt.replace(/\b((?:19|20)\d\d)\s*-\s*((?:19|20)\d\d)\b/g, function(_, a, b){
      hay = true; if(+a <= y && y <= +b) calza = true; return ' ';
    });
    (txt.match(/\b(19|20)\d\d\b/g) || []).forEach(function(s){ hay = true; if(+s === y) calza = true; });
    return calza ? 'calza' : (hay ? 'fuera' : '');
  }

  function waBusqueda(q){
    return '<div class="al-consulta-box"><div class="al-consulta-h">'+ic('wa')+' ¿No lo encuentras?</div>'+
      '<p>Escríbenos con el número o el repuesto y te confirmamos <b>disponibilidad y precio</b>.</p>'+
      '<a class="al-btn al-wa" target="_blank" rel="noopener" href="'+
      waLink('Hola! Busco este repuesto: '+q+'. ¿Me lo pueden cotizar?')+'">Consúltanos por WhatsApp</a></div>';
  }
  function bqCrumb(q){
    return '<div class="al-crumb"><a href="/#home">Inicio</a> › <b>Buscar: '+esc(q)+'</b></div>';
  }
  function bqHayFiltros(S){
    return (S.filters || []).some(function(f){
      return f.activos > 0 || f.min != null || f.max != null;
    });
  }
  function bqNormal(texto, motivo){
    location.replace('/search?type=product&q=' + enc(texto) + '&al_q=' + enc(texto) + '&al_modo=normal' +
      (motivo ? '&al_motivo=' + motivo : ''));
  }

  // Formas escritas del número según el fitment (oem_numbers y número del fabricante).
  function formasDelNumero(num){
    var n = normNum(num), vistas = {}, out = [];
    function sumar(s){
      s = String(s || '').trim();
      if(!s || normNum(s) !== n || vistas[s]) return;
      vistas[s] = 1; out.push(s);
    }
    return apiGet('/buscar-oem', {numero: num}).then(function(data){
      (data.articulos || []).forEach(function(a){
        (a.oem_numbers || []).forEach(function(o){
          sumar(o && typeof o === 'object' ? (o.articleNumber || o.oemNumber || o.numero) : o);
        });
        sumar(a.article_number);
      });
      // primero las que traen separadores: es como suelen venir escritas en los productos
      out.sort(function(a, b){ return (normNum(a) === a) - (normNum(b) === b); });
      return {formas: out.slice(0, BQ_MAX_FORMAS), data: data};
    });
  }
  function bqSugerir(q){
    var u = '/search/suggest.json?resources%5Btype%5D=product&resources%5Blimit%5D=10&q=' + enc(q);
    return fetch(u).then(function(r){ return r.ok ? r.json() : null; }).then(function(j){
      return (j && j.resources && j.resources.results && j.resources.results.products) || [];
    }).catch(function(){ return []; });
  }
  // Cuántos productos tiene la tienda para una forma exacta (entre comillas).
  function productosDeForma(forma){
    return bqSugerir('"' + forma + '"').then(function(l){ return l.length; });
  }

  function renderBusqueda(S){
    var qRaw = String(S.terms || '').trim();
    var estricta = /(^|[\s(])title:/.test(qRaw);
    var modo = paramUrl('al_modo');
    var orig = paramUrl(BQ_ORIG);
    var texto = paramUrl('al_q') || qRaw;
    document.title = (texto ? 'Buscar: ' + texto : 'Buscar') + ' | Allure Repuestos';
    var caja = document.getElementById('al-q');
    if(caja && !caja.value) caja.value = orig || texto.replace(/^"|"$/g, '');

    if(!qRaw){
      shell(bqCrumb('')+'<div class="al-h2">Buscar repuestos</div>'+
        '<div class="al-note">Escribe arriba el repuesto, el número de pieza o tu auto.</div>');
      return;
    }

    // Palabras que llegaron sin la consulta estricta (enlace viejo, #buscar): se mejora una vez.
    // allure-menu.js carga con defer, después que este archivo: se espera a que esté.
    if(!estricta && modo !== 'normal' && !orig){
      var subir = function(){
        var u = (window.ALMenu && ALMenu.urlBusqueda) ? ALMenu.urlBusqueda(qRaw) : '';
        if(u.indexOf('al_q=') >= 0){ location.replace(u); return; }
        bqSeguir(S, qRaw, texto, false, modo, orig);
      };
      if(window.ALMenu || document.readyState !== 'loading') subir();
      else document.addEventListener('DOMContentLoaded', subir);
      return;
    }
    bqSeguir(S, qRaw, texto, estricta, modo, orig);
  }

  function bqSeguir(S, qRaw, texto, estricta, modo, orig){
    if(estricta){
      var grupos = bqGrupos(qRaw);
      if(!(S.results_count > 0)){
        if(bqHayFiltros(S)){ bqPintarResultados(S, texto, orig, grupos, modo); return; }
        bqNormal(texto, 'sin_exactos'); return;
      }
      bqPintarResultados(S, texto, orig, grupos, modo);
      bqVerificarSintaxis(qRaw, grupos, texto);
      return;
    }

    if(S.results_count > 0 || bqHayFiltros(S)){ bqPintarResultados(S, texto, orig, null, modo); return; }

    var num = orig || qRaw;
    if(!pareceNumero(num)){ bqPintarVacio(texto); return; }

    shell(bqCrumb(texto)+'<div class="al-h2">Resultados para «'+esc(texto)+'»</div>'+
      '<div class="al-loading">Buscando el número en todas sus escrituras…</div>');

    // El puente se intenta UNA vez: si ya venimos de él (al_orig), directo a las fichas.
    if(orig){ bqFichasTecdoc(orig); return; }

    formasDelNumero(num).then(function(r){
      var formas = r.formas.filter(function(f){ return f !== qRaw; });
      if(!formas.length){ bqFichasTecdoc(num); return; }
      return Promise.all(formas.map(productosDeForma)).then(function(ns){
        var mejor = -1;
        ns.forEach(function(n, i){ if(n > 0 && (mejor < 0 || n > ns[mejor])) mejor = i; });
        if(mejor < 0){ bqFichasTecdoc(num); return; }
        var f = formas[mejor];
        // Con espacio va entre comillas: suelto, Shopify lo parte en dos palabras y trae ruido.
        var qNueva = /\s/.test(f) ? '"' + f + '"' : f;
        location.replace('/search?type=product&q=' + enc(qNueva) + '&' + BQ_ORIG + '=' + enc(num));
      });
    }).catch(function(){ bqPintarVacio(texto); });
  }

  /* Resguardo de la sintaxis, que Shopify no documenta: si la ignora, lo que devuelve ya no
     trae todas las palabras. Se revisa con el predictivo porque trae TODOS los tags del
     producto; los de la página son solo los de vehículo, y ahí "correa distribucion corolla"
     parecía fallar en 5 de 8 (la palabra venía del tag DISTRIBUCIÓN de Mundo Repuestos).
     No bloquea: la página ya está pintada y solo se va si de verdad no está filtrando. */
  var BQ_MAX_SIN_PALABRAS = 0.2;
  function bqVerificarSintaxis(q, grupos, texto){
    if(!grupos.length) return;
    bqSugerir(q).then(function(l){
      if(l.length < 3) return;                   // muestra chica: no se concluye nada
      var sin = l.filter(function(p){ return !bqTodas(grupos, bqTokensItem(p)); }).length;
      if(sin > l.length * BQ_MAX_SIN_PALABRAS) bqNormal(texto, 'sintaxis');
    });
  }

  function bqPintarVacio(q){
    shell(bqCrumb(q)+'<div class="al-h2">Resultados para «'+esc(q)+'»</div>'+
      '<div class="al-note">No encontramos productos para «'+esc(q)+'». Revisa cómo está escrito o prueba con menos palabras.</div>'+
      waBusqueda(q));
  }

  // Paso 3: la tienda no lo tiene. Las fichas TecDoc de siempre, con WhatsApp.
  function bqFichasTecdoc(num){
    apiGet('/buscar-oem', {numero: num}).then(function(data){
      var arts = data.articulos || [];
      if(!arts.length){ bqPintarVacio(num); return; }
      var cards = arts.map(function(a){
        var comprable = !!(a.tiene_producto && a.handle);
        return itemRow({
          dest: comprable ? 'location.href=\'/products/'+a.handle+'\'' : 'location.href=\'/#ficha/'+enc(a.article_key)+'\'',
          handle: comprable ? a.handle : '', imagen: a.imagen, badge: 'OEM',
          nombre: ((a.generic_desc||'')+' '+(a.article_number||'')).trim(),
          marca: a.mfr_name||'', precio: clpInt(a.precio), comprable: comprable
        });
      }).join('');
      shell(bqCrumb(num)+'<div class="al-h2">Referencias para «'+esc(num)+'»</div>'+
        '<div class="al-note">No tenemos publicado un producto con este número, pero lo identificamos en el catálogo técnico. '+
        'Escríbenos y te lo conseguimos.</div>'+
        waBusqueda(num)+
        '<div class="al-lista al-bq-fichas">'+cards+'</div>');
      hidratarFilas();
    }).catch(function(){ bqPintarVacio(num); });
  }

  function bqUrlCon(cambios){
    var p = new URLSearchParams(location.search);
    for(var k in cambios){
      if(cambios[k] === null || cambios[k] === '') p.delete(k); else p.set(k, cambios[k]);
    }
    p.delete('page');
    p.delete('al_pag');
    return '/search?' + p.toString();
  }

  function bqFila(it, chip){
    var t = parseTitulo(it.title);
    var marca = t.marca || (/allure/i.test(it.vendor || '') ? '' : (it.vendor || ''));
    return itemRow({
      dest: 'location.href=\''+String(it.url).replace(/'/g, '%27')+'\'', handle: it.handle, imagen: it.image,
      badge: '', nombre: t.nombre, marca: marca, precio: clpInt(it.price), comprable: !!it.available, chip: chip
    });
  }

  /* Paginación: si Liquid entregó TODOS los resultados (≤250, ver allure-busqueda.liquid) se
     pagina acá de a 24, porque el orden por año tiene que ver el conjunto entero: en
     "pastillas de freno hilux 2015" Shopify ponía las 19 que calzan en las páginas 2 y 3.
     Con más de 250, manda la paginación de Shopify y el año ordena solo dentro de la página. */
  var BQ_POR_PAGINA = 24;
  var BQ_ESTADO = null;

  function bqPintarResultados(S, q, orig, grupos, modo, pagina){
    BQ_ESTADO = [S, q, orig, grupos, modo];
    var n = S.results_count || 0;
    var anio = grupos ? paramUrl('al_anio') : '';
    var todos = (S.items || []).length >= n && n > 0;
    pagina = pagina || parseInt(paramUrl('al_pag'), 10) || 1;
    // Shopify no cuenta más allá de 1.000: ese número es un tope, no el total.
    var cont = n >= 1000 ? '1.000 o más productos' : (n === 1 ? '1 producto' : n.toLocaleString('es-CL') + ' productos');
    var aviso = '';
    if(orig){
      aviso = '<div class="al-note">Mostramos «'+esc(String(S.terms).replace(/"/g,''))+'»: es el mismo número que buscaste («'+esc(orig)+'») escrito de otra forma.</div>';
    } else if(modo === 'normal' && n > 0){
      aviso = '<div class="al-note">No encontramos productos con todas las palabras de «'+esc(q)+'». '+
        'Te mostramos los más parecidos: revisa cómo está escrito.</div>';
    }

    var items = (S.items || []).slice();
    var marcas = items.map(function(it){ return anio ? bqAnio(it, grupos, anio) : ''; });
    if(anio){
      // Orden por año solo con relevancia: si el cliente eligió ordenar por precio, manda eso.
      if(!S.sort_by || S.sort_by === 'relevance'){
        var peso = {calza: 0, '': 1, fuera: 2};
        var idx = items.map(function(_, i){ return i; });
        idx.sort(function(a, b){ return (peso[marcas[a]] - peso[marcas[b]]) || (a - b); });
        items = idx.map(function(i){ return S.items[i]; });
        marcas = idx.map(function(i){ return marcas[i]; });
      }
      var nCalza = marcas.filter(function(m){ return m === 'calza'; }).length;
      aviso += '<div class="al-bq-anio-nota">'+(nCalza
        ? (todos ? 'Primero' : 'En esta página, primero')+' los que indican <b>'+esc(anio)+'</b> en su rango de años ('+nCalza+').'
        : (todos ? 'Ninguno indica <b>'+esc(anio)+'</b> en el título: revisa la ficha o escríbenos.'
                 : 'En esta página ninguno indica <b>'+esc(anio)+'</b> en el título.'))+'</div>';
    }

    var paginas = todos ? Math.max(1, Math.ceil(items.length / BQ_POR_PAGINA)) : 1;
    if(todos){
      pagina = Math.min(Math.max(1, pagina), paginas);
      var desde = (pagina - 1) * BQ_POR_PAGINA;
      items = items.slice(desde, desde + BQ_POR_PAGINA);
      marcas = marcas.slice(desde, desde + BQ_POR_PAGINA);
    }

    var filas = items.map(function(it, i){
      var chip = marcas[i] === 'calza' ? '<span class="al-item-tag al-anio-ok">Calza con '+esc(anio)+'</span>'
               : marcas[i] === 'fuera' ? '<span class="al-item-tag al-anio-no">No indica '+esc(anio)+'</span>' : '';
      return bqFila(it, chip);
    }).join('');
    if(!filas){
      filas = '<div class="al-note">Ningún producto cumple esos filtros. <a href="'+esc(conAl(S.clear_url) || urlBusqueda(q))+'">Quitar filtros</a></div>';
    }

    var orden = (S.sort_options || []).map(function(o){
      var sel = (o.value === (S.sort_by || S.default_sort_by)) ? ' selected' : '';
      return '<option value="'+esc(o.value)+'"'+sel+'>'+esc(o.name)+'</option>';
    }).join('');

    var pg = S.paginate || {};
    var ultima = todos ? pagina >= paginas : (!pg.pages || pg.current >= pg.pages);
    var pagsHTML = todos ? bqPaginasLocales(pagina, paginas) : bqPaginasHTML(S);

    shell(bqCrumb(q)+
      '<div class="al-bq-cab"><div class="al-h2">Resultados para «'+esc(q)+'»</div>'+
      '<div class="al-bq-cont">'+cont+'</div></div>'+
      aviso+
      '<div class="al-bq-barra">'+
        '<button type="button" class="al-bq-btn-filtros" onclick="AL.bqFiltros()">Filtrar'+
          (bqHayFiltros(S) ? ' <b class="al-bq-dot"></b>' : '')+'</button>'+
        (orden ? '<label class="al-bq-orden">Ordenar <select onchange="AL.bqOrden(this.value)">'+orden+'</select></label>' : '')+
      '</div>'+
      '<div class="al-bq-grid">'+
        '<aside class="al-bq-filtros" id="al-bq-filtros">'+bqFiltrosHTML(S)+'</aside>'+
        '<div class="al-bq-main"><div class="al-lista">'+filas+'</div>'+pagsHTML+
        (grupos && n > 0 && ultima && !bqHayFiltros(S) ? '<div id="al-bq-tambien"></div>' : '')+
        (n === 0 ? '' : '<div class="al-bq-wa">'+waBusqueda(q)+'</div>')+'</div>'+
      '</div>');
    hidratarFilas();
    if(grupos && n > 0 && ultima && !bqHayFiltros(S)) bqTambien(S, grupos);
  }

  /* --- "También podría interesarte" ---
     Suelta UNA palabra por vez, y solo si es de la PIEZA: está en el tipo de producto de la
     mayoría de los resultados exactos Y no aparece en sus tags de vehículo (veh:, modelo:,
     marca_vehiculo:). Lo segundo cubre "Frenos Ford": ahí la marca del auto vive en el tipo.
     Sin auto en la búsqueda no se muestra: sin él, soltar la pieza trae cualquier cosa. */
  function bqTambien(S, grupos){
    var its = S.items || [];
    if(grupos.length < 2 || !its.length) return;
    var tipos = its.map(function(it){ return bqTokens(it.type); });
    var vts = its.map(function(it){ return bqTokens((it.vt || []).join(' ')); });
    function enVehiculo(g){ return vts.some(function(t){ return bqCalza(g, t); }); }
    function enTipo(g){ return tipos.filter(function(t){ return bqCalza(g, t); }).length * 2 > its.length; }
    var soltables = [], hayAuto = false;
    grupos.forEach(function(g, i){
      if(enVehiculo(g)) hayAuto = true;
      else if(enTipo(g)) soltables.push(i);
    });
    if(!soltables.length || !hayAuto) return;
    function grupoQ(g){ return '(' + g.map(function(v){ return 'title:'+v+' OR tag:'+v; }).join(' OR ') + ')'; }
    Promise.all(soltables.map(function(i){
      return bqSugerir(grupos.filter(function(_, j){ return j !== i; }).map(grupoQ).join(' AND '));
    })).then(function(listas){
      // Se alternan las listas: soltando "filtro" en "filtro aceite corolla" salen 10 aceites y,
      // en orden, taparían los filtros de aire y cabina que salen soltando "aceite".
      var vistos = {}, out = [], largo = Math.max.apply(null, listas.map(function(l){ return l.length; }));
      for(var j = 0; j < largo && out.length < BQ_MAX_TAMBIEN; j++){
        listas.forEach(function(l){
          var p = l[j];
          if(!p || out.length >= BQ_MAX_TAMBIEN || vistos[p.handle]) return;
          vistos[p.handle] = 1;
          if(bqTodas(grupos, bqTokensItem(p))) return;          // es exacto: ya está arriba
          out.push(p);
        });
      }
      var cont = document.getElementById('al-bq-tambien');
      if(!out.length || !cont) return;
      cont.innerHTML = '<div class="al-h2 al-bq-tambien-h">También podría interesarte</div>'+
        '<div class="al-bq-tambien-sub">Para el mismo auto, sin todas las palabras que buscaste.</div>'+
        '<div class="al-lista">'+out.map(function(p){
          return bqFila({title: p.title, url: p.url, handle: p.handle, image: p.image || p.featured_image,
                         vendor: p.vendor, price: p.price, available: p.available}, '');
        }).join('')+'</div>';
      hidratarFilas();
    });
  }

  function bqFiltrosHTML(S){
    var html = (S.filters || []).map(function(f){
      if(f.type === 'price_range'){
        var p = function(v){ return v == null ? '' : v; };
        return '<div class="al-bq-f"><div class="al-bq-f-h">'+esc(f.label)+'</div>'+
          '<form class="al-bq-precio" onsubmit="return AL.bqPrecio(event, this)">'+
            '<input type="number" inputmode="numeric" min="0" name="'+esc(f.min_param)+'" value="'+esc(p(f.min))+'" placeholder="Desde">'+
            '<input type="number" inputmode="numeric" min="0" name="'+esc(f.max_param)+'" value="'+esc(p(f.max))+'" placeholder="Hasta">'+
            '<button type="submit">Aplicar</button>'+
          '</form></div>';
      }
      var vals = (f.values || []).filter(function(v){ return v.count > 0 || v.active; });
      if(!vals.length) return '';
      return '<div class="al-bq-f"><div class="al-bq-f-h">'+esc(f.label)+'</div>'+
        vals.map(function(v){
          return '<a class="al-bq-op'+(v.active ? ' on' : '')+'" href="'+esc(conAl(v.active ? v.remove : v.add))+'">'+
            '<span class="al-bq-check" aria-hidden="true"></span><span class="al-bq-op-t">'+esc(v.label)+'</span>'+
            '<span class="al-bq-op-n">'+v.count+'</span></a>';
        }).join('')+'</div>';
    }).join('');
    if(bqHayFiltros(S) && S.clear_url){
      html = '<a class="al-bq-limpiar" href="'+esc(conAl(S.clear_url))+'">Quitar filtros</a>' + html;
    }
    return html || '<div class="al-bq-f-vacio">Sin filtros para esta búsqueda.</div>';
  }

  function bqPaginasLocales(actual, total){
    if(total <= 1) return '';
    var partes = [];
    for(var i = 1; i <= total; i++){
      if(i === 1 || i === total || Math.abs(i - actual) <= 1){
        partes.push(i === actual ? '<span class="al-bq-pag on">'+i+'</span>'
          : '<a class="al-bq-pag" href="'+esc(bqUrlPagina(i))+'" onclick="return AL.bqPagina('+i+')">'+i+'</a>');
      } else if(partes[partes.length - 1] !== '…'){
        partes.push('…');
      }
    }
    partes = partes.map(function(p){ return p === '…' ? '<span class="al-bq-pag gap">…</span>' : p; });
    return '<nav class="al-bq-pags" aria-label="Páginas">'+
      (actual > 1 ? '<a class="al-bq-pag nav" href="'+esc(bqUrlPagina(actual-1))+'" onclick="return AL.bqPagina('+(actual-1)+')">‹ Anterior</a>' : '')+
      partes.join('')+
      (actual < total ? '<a class="al-bq-pag nav" href="'+esc(bqUrlPagina(actual+1))+'" onclick="return AL.bqPagina('+(actual+1)+')">Siguiente ›</a>' : '')+
      '</nav>';
  }
  function bqUrlPagina(i){
    var p = new URLSearchParams(location.search);
    if(i > 1) p.set('al_pag', i); else p.delete('al_pag');
    return '/search?' + p.toString();
  }

  function bqPaginasHTML(S){
    var pg = S.paginate;
    if(!pg || pg.pages <= 1) return '';
    var partes = (pg.parts || []).map(function(p){
      if(!p.is_link){
        return /^\d+$/.test(String(p.title))
          ? '<span class="al-bq-pag on">'+esc(p.title)+'</span>'
          : '<span class="al-bq-pag gap">…</span>';
      }
      return '<a class="al-bq-pag" href="'+esc(conAl(p.url))+'">'+esc(p.title)+'</a>';
    }).join('');
    return '<nav class="al-bq-pags" aria-label="Páginas">'+
      (pg.prev ? '<a class="al-bq-pag nav" href="'+esc(conAl(pg.prev))+'">‹ Anterior</a>' : '')+
      partes+
      (pg.next ? '<a class="al-bq-pag nav" href="'+esc(conAl(pg.next))+'">Siguiente ›</a>' : '')+
      '</nav>';
  }

  /* ---------- FRENOS por patente/VIN: página de navegación normal (JP 2026-07-29) ----------
     Antes los resultados se desplegaban en un panel INLINE sobre el home (allure-frenos-home.js),
     lo que desordenaba la navegación. Ahora el cajón del home solo redirige a #frenos/PATENTE y
     esta vista renderiza los mismos datos como cualquier categoría del sitio: breadcrumb, título
     y el listado vertical estilo ML (itemRow), un bloque por tipo/eje de freno. */
  function viewFrenos(q){
    q = (q||'').trim().toUpperCase().replace(/[^A-Z0-9]/g,'');
    if(q.length < 4){
      shell('<div class="al-crumb"><a href="#home">Inicio</a> › <b>Frenos</b></div>'+
        '<div class="al-note">Escribe una patente válida (ej: BCDF12) o tu número de chasis.</div>');
      return Promise.resolve();
    }
    var param = q.length > 8 ? {vin:q} : {patente:q};
    return apiGet('/frenos-patente', param).then(function(r){
      var crumb = '<div class="al-crumb"><a href="#home">Inicio</a> › <b>Frenos: '+esc(q)+'</b></div>';
      // No se pudo resolver la patente o no hay opciones: mensaje + WhatsApp, como página normal.
      if(!r || !r.ok || !(r.grupos||[]).length){
        var v0 = (r && r.vehiculo) || null;
        var vTxt = v0 ? (v0.marca+' '+v0.modelo+' '+(v0.ano||'')).replace(/\s+/g,' ').trim() : ('patente '+q);
        var m0 = (r && r.mensaje) ? r.mensaje : 'No encontramos opciones de freno publicadas para tu vehículo.';
        shell(crumb+
          (v0 ? '<div class="al-h2">Frenos para '+esc(vTxt)+'</div>' : '<div class="al-h2">Frenos</div>')+
          '<div class="al-consulta-box"><div class="al-consulta-h">'+ic('wa')+' '+esc(m0)+'</div>'+
          '<p>Escríbenos y te confirmamos <b>disponibilidad y precio</b> al instante — te los conseguimos.</p>'+
          '<a class="al-btn al-wa" target="_blank" rel="noopener" href="'+
          waLink('Hola! Necesito frenos para mi '+vTxt+'. ¿Qué opciones tienen?')+'">Consúltanos por WhatsApp</a></div>');
        return;
      }
      var v = r.vehiculo || {};
      var vehTxt = (v.marca+' '+v.modelo).replace(/\s+/g,' ').trim();
      var sub = [v.ano, v.cilindrada ? v.cilindrada+' L' : ''].filter(Boolean).join(' · ');
      var html = '';
      (r.grupos||[]).forEach(function(g){
        var filas = (g.opciones||[]).map(function(o){
          // mismo molde de nombre que el catálogo: tipo + MARCA + número de parte
          var nom = (g.titulo+' '+(o.marca||'')+' '+(o.sku||'')).replace(/\s+/g,' ').trim();
          return itemRow({
            dest: 'location.href=\'/products/'+enc(o.handle)+'\'',
            handle: o.handle, imagen: o.imagen || '', badge: 'Allure',
            nombre: nom, marca: o.marca||'', precio: clpInt(o.precio), comprable: true
          });
        }).join('');
        html += '<div class="al-h2">'+esc(g.titulo)+'</div><div class="al-lista">'+filas+'</div>';
      });
      shell(crumb+
        '<div class="al-h2">Frenos para '+esc(vehTxt)+(sub?' <small style="font-weight:400;color:#888">'+esc(sub)+'</small>':'')+'</div>'+
        '<div class="al-maestro-sub">'+esc(r.total||0)+' opciones disponibles para tu vehículo:</div>'+
        (r.aproximado ? '<div class="al-note">Lista aproximada según el modelo de tu auto: confírmala con nosotros antes de comprar.</div>' : '')+
        html);
      hidratarFilas();
    });
  }

  // mini íconos inline (para el bloque WhatsApp)
  function ic(name){
    if(name==='wa') return '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.3A10 10 0 1 0 12 2Zm5.1 14.1c-.2.6-1.2 1.1-1.7 1.2-.4.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.5-2.6-1.1-4.3-3.8-4.4-4-.1-.2-1-1.4-1-2.6 0-1.2.6-1.8.9-2.1.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2 0 .4 0 .5l-.4.5c-.2.2-.3.4-.1.7.2.3.9 1.4 1.9 2 .8.5 1.1.6 1.3.5.2-.1.4-.5.6-.8.2-.3.4-.2.6-.1l1.8.9c.3.1.4.2.5.3.1.2.1.6-.1 1.2Z"/></svg>';
    // Íconos stroke — MISMOS paths que snippets/al-icon.liquid (mantener sincronizados).
    var S='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
    if(name==='car')    return S+'<path d="M5 13 6.5 8.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13"/><path d="M3 17v-2.5A1.5 1.5 0 0 1 4.5 13h15a1.5 1.5 0 0 1 1.5 1.5V17a1 1 0 0 1-1 1h-1"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';
    if(name==='shield') return S+'<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></svg>';
    if(name==='lock')   return S+'<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
    if(name==='cart')   return S+'<circle cx="9" cy="20" r="1.6"/><circle cx="17" cy="20" r="1.6"/><path d="M2 3h3l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h7.7a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>';
    if(name==='oem')    return S+'<path d="M12 3.2 14.3 6l3.6.4 1 3.5 2.6 2.6-2 3-.6 3.6-3.5.7L12 21.8l-3.4-2-3.5-.7-.6-3.6-2-3L5.1 9.9l1-3.5L9.7 6 12 3.2Z"/><path d="m9.2 12.2 2 2 3.6-3.7"/></svg>';
    if(name==='truck')  return S+'<path d="M1 4h13v11H1z"/><path d="M14 8h4l3 3v4h-7"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';
    return '';
  }

  /* --- Verificador: constantes y comparación ---------------------------------
     Se comparan textos normalizados (sin acentos, sin guiones): "F-150" y "f150" son
     el mismo modelo, y "MORNING" calza con "KIA MORNING 2008". La lista de la pieza sale
     del propio molde (m.compat), así que la comparación es instantánea y no pega otra vez
     a la API. El año, cuando se puede leer del título, solo MATIZA: nunca convierte un sí
     en un no, porque muchos títulos traen un año de ejemplo y no el rango completo. */
  var NOM_INPUT = 'al-patente', NOM_RES = 'al-verif-res', NOM_BTN = 'al-verif-btn', NOM_NOTA = 'al-verif-note';
  var PT_TAB = '.al-verif-tab', CLS_ON = 'on', CLS_RES = 'al-verif-res', CLS_CARGA = 'cargando';
  var CLS_OK = 'ok', CLS_DUDA = 'duda', CLS_NO = 'no', SP = ' ', EMPTY = '';
  var MODO_VIN = 'vin', EP_PAT = '/frenos-patente', EP_VERIF = '/verificar';
  var PH_PAT = 'EJ: GFBY98', PH_VIN = 'EJ: 9BWZZZ377VT004251';
  var NOTA_PAT = 'Ingresa la patente de tu vehículo (sin guión).';
  var NOTA_VIN = 'Son los 17 caracteres del chasis. Están en tu permiso de circulación.';
  var T_VERIFICAR = 'Verificar', T_BUSCANDO = 'Buscando…', M_BUSCANDO = ' Buscando tu vehículo…';
  var T_CORTO = 'Falta el dato';
  var M_CORTO_PAT = 'Escribe la patente completa, sin guión (ejemplo: GFBY98).';
  var M_CORTO_VIN = 'El número de chasis tiene 17 caracteres.';
  var SPIN = '<span class="giro"></span>';
  var ICO_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8.5 12.2 2.4 2.4 4.6-4.9"/></svg>';
  var ICO_DUDA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16.2h.01"/></svg>';
  var ICO_NO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m9 9 6 6M15 9l-6 6"/></svg>';

  function vnorm(s){
    s = String(s == null ? EMPTY : s).toLowerCase();
    s = s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, EMPTY) : s;
    return s.replace(/[^a-z0-9]/g, EMPTY);
  }

  /* Años que aparecen en el título de la pieza: sirven de referencia, no de filtro. */
  function aniosDelTitulo(t){
    var m = String(t || EMPTY).match(/\b(19[89]\d|20[0-4]\d)\b/g);
    if(!m || !m.length) return null;
    var ns = m.map(Number);
    return {desde: Math.min.apply(null, ns), hasta: Math.max.apply(null, ns)};
  }

  function verifPinta(clase, icono, titulo, texto, veh, waTexto){
    var res = document.getElementById(NOM_RES);
    if(!res) return;
    var fichaVeh = EMPTY;
    if(veh){
      var partes = [];
      if(veh.marca)      partes.push('<span>Marca <b>' + esc(veh.marca) + '</b></span>');
      if(veh.modelo)     partes.push('<span>Modelo <b>' + esc(veh.modelo) + '</b></span>');
      if(veh.ano)        partes.push('<span>Año <b>' + esc(veh.ano) + '</b></span>');
      if(veh.version)    partes.push('<span>Versión <b>' + esc(veh.version) + '</b></span>');
      if(veh.cilindrada) partes.push('<span>Motor <b>' + esc(veh.cilindrada) + '</b></span>');
      if(partes.length) fichaVeh = '<div class="al-verif-veh">' + partes.join(EMPTY) + '</div>';
    }
    var boton = waTexto
      ? '<a class="al-btn al-wa" target="_blank" rel="noopener" href="' + waLink(waTexto) + '">Confirmar por WhatsApp</a>'
      : EMPTY;
    res.hidden = false;
    res.className = CLS_RES + SP + clase;
    res.innerHTML = '<div class="tit">' + icono + esc(titulo) + '</div><p>' + texto + '</p>' + fichaVeh + boton;
  }

  /* REGISTRO DEL VERIFICADOR (JP 2026-09-15). Manda producto, veredicto y el vehiculo que
     devolvio el resolvedor. NUNCA la patente ni el chasis. Lee el veredicto del resultado ya
     pintado, asi no toca la logica de verifVeredicto. Si falla, no pasa nada: es fuego y olvido. */
  function verifRegistrar(r, esVin){
    try {
      var res = document.getElementById(NOM_RES);
      if(!res || !API) return;
      var v = /\bok\b/.test(res.className) ? 'ok' : (/\bno\b/.test(res.className) ? 'no' : 'duda');
      var tit = res.querySelector('.tit');
      var veh = (r && r.vehiculo) || {};
      var P = window.ALLURE_PRODUCT || {};
      var p = {h: P.handle || location.hash || location.pathname, s: P.sku || '', v: v,
               t: tit ? tit.textContent : '', ma: veh.marca || '', mo: veh.modelo || '',
               an: veh.ano || '', ve: veh.version || '', ci: veh.cilindrada || '',
               fp: P.ficha_propia === true ? '1' : '0', m: esVin ? 'vin' : 'patente'};
      var a = []; for(var k in p){ a.push(enc(k) + '=' + enc(p[k])); }
      fetch(API + '/verif-log?' + a.join('&'), {keepalive: true}).catch(function(){});
    } catch(e) {}
  }

  /* VEREDICTO (JP 2026-09-17): lo decide el servidor —GET /verificar?patente=&producto=— con la
     compatibilidad escrita del producto y la identidad de modelo aprobada (verificador/servicio.py en
     motorcotizaciones). Antes se decidia aca, comparando marca y la primera palabra del modelo con el
     titulo: colgaba un Gol en un Golf VII. Tres respuestas: COMPATIBLE · NO_COMPATIBLE (con alternativa
     si la hay) · NO_CONFIRMADO (WhatsApp). Si las versiones del auto responden distinto, se pregunta la
     version con la misma lista que usa la navegacion. */
  var NC_TEXTO = {
    patente_no_encontrada: 'No encontramos datos para esa patente. Revisa que esté bien escrita o escríbenos y lo confirmamos nosotros.',
    fitment_incompleto: 'Esta pieza todavía no tiene publicada su lista completa de vehículos, así que te lo confirmamos nosotros al instante.',
    rango_de_anios_abierto: 'Tu versión aparece, pero no tenemos confirmados los años de tu auto. Te lo confirmamos nosotros al instante.',
    no_esta_la_mia: 'Sin tu versión exacta no te lo podemos asegurar. Te lo confirmamos nosotros al instante.',
    chasis: 'Con el número de chasis te lo confirmamos nosotros al instante.'
  };
  var NC_DEFECTO = 'No pudimos confirmar tu versión exacta con la patente. Te lo confirmamos nosotros al instante.';

  function verifVeh(v, cand){
    if(!v) return null;
    return {marca: v.marca, modelo: v.modelo, ano: v.anio,
            version: cand ? [cand.serie, cand.motorizacion].filter(Boolean).join(SP) : EMPTY};
  }

  /* LO QUE SI SIRVE PARA SU AUTO (JP 2026-09-23). En los frenos, el "no" ya no deriva a
     WhatsApp: el servicio devuelve `opciones` —los frenos que el PROVEEDOR declara para esa
     patente y que estan publicados— y se pintan con el MISMO `itemRow` de la navegacion y del
     buscador del home, asi que la foto, la marca y el precio de lista los completa
     `hidratarFilas()` preguntandole a la tienda. La pagina con TODO sigue siendo #frenos/PATENTE,
     que es donde lleva el enlace del pie cuando hay mas de las que caben. */
  function verifOpcionesHTML(ops, q){
    var bloques = (ops.grupos || []).map(function(g){
      var filas = (g.opciones || []).map(function(o){
        return itemRow({
          dest: 'location.href=\'/products/'+enc(o.handle)+'\'',
          handle: o.handle, imagen: o.imagen || EMPTY, nombre: o.titulo,
          marca: o.marca || EMPTY, precio: clpInt(o.precio), comprable: true
        });
      }).join(EMPTY);
      return '<div class="al-verif-ops-t">'+esc(g.titulo)+'</div><div class="al-lista">'+filas+'</div>';
    }).join(EMPTY);
    var mas = (ops.total > ops.mostradas)
      ? '<a class="al-verif-ops-mas" href="'+HP+'#frenos/'+enc(q)+'">Ver los '+esc(ops.total)+
        ' frenos de tu vehículo ›</a>'
      : EMPTY;
    return '<div class="al-verif-ops">'+bloques+mas+'</div>';
  }

  function verifFinal(ver, motivo, q, v, cand, alt, ops){
    var pieza = VERIF.titulo || 'este repuesto';
    var vehTxt = v ? [v.marca, v.modelo, v.anio].filter(Boolean).join(SP) : EMPTY;
    var etiqueta = (q.length > 8 ? 'chasis ' : 'patente ') + q;
    var waMsg = 'Hola, tengo un ' + (vehTxt || 'auto') + ' (' + etiqueta + ') y quiero confirmar si me sirve: ' + pieza;
    var veh = verifVeh(v, cand);
    if(ver === 'COMPATIBLE'){
      verifPinta(CLS_OK, ICO_OK, 'Sí, es compatible con tu vehículo',
        'Tu <b>' + esc(vehTxt) + '</b> está en la lista de compatibilidad de esta pieza.', veh, null);
    } else if(ver === 'NO_COMPATIBLE'){
      if(ops && ops.grupos && ops.grupos.length){
        verifPinta(CLS_NO, ICO_NO, 'Esta no es para tu vehículo',
          'Para tu <b>' + esc(vehTxt) + '</b> ' + (ops.misma_pieza ? 'tenemos estas:' : 'tenemos estos frenos:'),
          veh, null);
        var resOps = document.getElementById(NOM_RES);
        if(resOps){
          resOps.insertAdjacentHTML('beforeend', verifOpcionesHTML(ops, q));
          hidratarFilas();
        }
      } else if(alt && alt.handle){
        verifPinta(CLS_NO, ICO_NO, 'Esta no es para tu vehículo',
          'Para tu <b>' + esc(vehTxt) + '</b> tenemos esta otra:', veh, null);
        var res = document.getElementById(NOM_RES);
        if(res) res.insertAdjacentHTML('beforeend', '<button type="button" class="al-btn" onclick="location.href=\'/products/' + enc(alt.handle) + "\'\">" +
          esc(alt.titulo) + (alt.precio ? ' · ' + esc(clpInt(alt.precio)) : EMPTY) + '</button>');
      } else {
        verifPinta(CLS_NO, ICO_NO, 'Esta no es para tu vehículo',
          'Esta pieza no está publicada para tu <b>' + esc(vehTxt) + '</b>. Escríbenos y te conseguimos la que sí corresponde.',
          veh, waMsg);
      }
    } else {
      verifPinta(CLS_DUDA, ICO_DUDA, v ? 'Encontramos tu vehículo' : 'No pudimos identificar tu vehículo',
        (v ? 'Es un <b>' + esc(vehTxt) + '</b>. ' : EMPTY) + (NC_TEXTO[motivo] || NC_DEFECTO), veh, waMsg);
    }
  }

  function verifVeredicto(r, q){
    if(!r || r.ok === false){
      verifFinal('NO_CONFIRMADO', r ? r.motivo : EMPTY, q, null, null, null);
      return;
    }
    if(r.veredicto){
      var unico = r.candidatos && r.candidatos.length === 1 ? r.candidatos[0] : null;
      verifFinal(r.veredicto, r.motivo, q, r.vehiculo, unico, r.alternativa, r.opciones);
      return;
    }
    /* Las versiones responden distinto: se pregunta cual es, con la lista de "elige la version". */
    var v = r.vehiculo, res = document.getElementById(NOM_RES);
    if(!res) return;
    var filas = r.candidatos.map(function(c, k){
      var sub = [c.hp ? c.hp + ' HP' : EMPTY, c.anios].filter(Boolean).join(' · ');
      return '<a class="al-row" href="#" data-i="' + k + '"><span>' + esc([c.serie, c.motorizacion].filter(Boolean).join(SP)) +
        '</span><span class="al-row-sub">' + esc(sub) + '</span></a>';
    }).join(EMPTY) + '<a class="al-row" href="#" data-i="-1"><span>No está la mía</span></a>';
    res.hidden = false;
    res.className = CLS_RES + SP + 'info';
    res.innerHTML = '<div class="tit">' + ICO_DUDA + 'Tu auto tiene varias versiones</div>' +
      '<p>¿Cuál es la de tu <b>' + esc([v.marca, v.modelo, v.anio].filter(Boolean).join(SP)) + '</b>?</p>' +
      '<div class="al-list">' + filas + '</div>';
    Array.prototype.forEach.call(res.querySelectorAll('.al-row'), function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        var k = parseInt(a.getAttribute('data-i'), 10);
        if(k < 0) verifFinal('NO_CONFIRMADO', 'no_esta_la_mia', q, v, null, null);
        else { var c = r.candidatos[k]; verifFinal(c.veredicto, c.motivo, q, v, c, c.alternativa); }
        verifRegistrar({vehiculo: verifVeh(v, k < 0 ? null : r.candidatos[k])}, false);
      });
    });
  }

  window.AL = {
    /* Vista previa de la tracción unificada: olvidar la tracción que trajo la patente. */
    tuTodas: function(lt){
      tuOlvidar(lt);
      for(var k in MEM){ delete MEM[k]; }
      route();
      return false;
    },
    /* El año del auto: "Ver todos" lo olvida en ese vehículo (JP 2026-10-13). */
    anTodos: function(lt){
      anOlvidar(lt);
      for(var k in MEM){ delete MEM[k]; }
      route();
      return false;
    },
    /* Cajon de patente de la portada (JP 2026-10-09): solo lleva a #patente/XXXX99. */
    patente: function(f){
      var q = patLimpia(f && f.patente && f.patente.value);
      if(q.length < 5 || q.length > 6){ if(f && f.patente) f.patente.focus(); return false; }
      location.hash = '#patente/'+q;
      return false;
    },
    /* Recuadro de patente dentro de Frenos (JP 2026-10-12): resuelve la patente y vuelve a Frenos. */
    patenteFrenos: function(f){
      var q = patLimpia(f && f.patente && f.patente.value);
      if(q.length < 5 || q.length > 6){ if(f && f.patente) f.patente.focus(); return false; }
      try{ sessionStorage.setItem('al_pat_destino', 'Frenos'); }catch(e){}
      location.hash = '#patente/'+q;
      return false;
    },
    /* Galería de la ficha. `paso` es -1/+1 desde las flechas o el dedo, o el índice exacto
       cuando viene de un punto (dot=true). Da la vuelta al llegar al final. */
    gal: function(el, paso, dot){
      var raiz = el.closest ? el.closest('.al-gal') : null;
      if(!raiz) return;
      var slides = raiz.querySelectorAll('.al-gal-slide');
      var dots = raiz.querySelectorAll('.al-gal-dot');
      var thumbs = raiz.querySelectorAll('.al-gal-thumb');
      if(!slides.length) return;
      var actual = 0;
      slides.forEach(function(s, i){ if(s.classList.contains('on')) actual = i; });
      var i = dot ? paso : (actual + paso);
      i = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.classList.toggle('on', k === i); });
      dots.forEach(function(d, k){ d.classList.toggle('on', k === i); });
      thumbs.forEach(function(t, k){
        t.classList.toggle('on', k === i);
        /* si la fila está desplazada, la miniatura activa se trae a la vista */
        if(k === i && t.scrollIntoView) t.scrollIntoView({block:'nearest', inline:'nearest'});
      });
    },
    buscar: function(e){ e.preventDefault(); var q=document.getElementById('al-q').value.trim(); if(q) location.href=urlBusqueda(q); return false; },
    /* ---- Página de resultados /search ---- */
    bqOrden: function(v){ location.href = bqUrlCon({sort_by: v, al_pag: null}); },
    bqPagina: function(i){
      if(!BQ_ESTADO) return true;                 // sin estado, que el enlace recargue
      try{ history.replaceState(null, '', bqUrlPagina(i)); }catch(e){}
      bqPintarResultados.apply(null, BQ_ESTADO.concat([i]));
      window.scrollTo(0, 0);
      return false;
    },
    bqFiltros: function(){
      var el = document.getElementById('al-bq-filtros');
      if(el) el.classList.toggle('abierto');
    },
    bqPrecio: function(e, form){
      if(e) e.preventDefault();
      var c = {};
      [].forEach.call(form.querySelectorAll('input'), function(i){
        c[i.name] = String(i.value || '').replace(/\D/g, '');
      });
      location.href = bqUrlCon(c);
      return false;
    },

    /* La imagen del vehículo (URL del crawl TecDoc) no cargó — token expirado / 403 / offline.
       Reemplaza el <img> por la silueta neutra para que NUNCA quede una imagen rota. */
    vehImgFail: function(img){
      if(img && img.parentNode){
        var panel=img.parentNode;               // .al-modelo-img
        var box=document.createElement('div'); box.innerHTML=CAR_SIL;
        panel.replaceChild(box.firstChild, img);
        var cap=panel.querySelector('.al-modelo-cap');
        if(cap) cap.textContent='Imagen referencial no disponible';
      }
    },
    /* El logo grande de la cabecera de marca no cargó -> se quita el panel (sin hueco ni
       imagen rota). No hay fallback a inicial: el nombre de la marca ya está en el título. */
    marcaLogoFail: function(img){
      var p = img && img.parentNode;            // .al-marca-logo
      if(p && p.parentNode) p.parentNode.removeChild(p);
    },
    /* El logo de marca no cargó (api caído / marca sin logo) -> vuelve al chip con la inicial. */
    brandImgFail: function(img){
      if(img && img.parentNode){
        var s = img.parentNode;                 // .al-brand-logo
        s.classList.remove('al-logo-img');      // restaura fondo/borde del chip
        s.textContent = img.dataset.ini || '';
      }
    },
    qty: function(d){ var i=document.getElementById('al-qty'); if(!i) return; i.value=Math.max(1,(parseInt(i.value,10)||1)+d); },
    /* ---- Verificador de compatibilidad ---- */
    verifModo: function(btn, modo){
      var i = document.getElementById(NOM_INPUT), n = document.getElementById(NOM_NOTA);
      if(!i) return;
      btn.parentNode.querySelectorAll(PT_TAB).forEach(function(t){ t.classList.remove(CLS_ON); });
      btn.classList.add(CLS_ON);
      i.dataset.modo = modo;
      if(modo === MODO_VIN){
        i.maxLength = 17; i.placeholder = PH_VIN;
        if(n) n.textContent = NOTA_VIN;
      } else {
        i.maxLength = 8; i.placeholder = PH_PAT;
        if(n) n.textContent = NOTA_PAT;
      }
      i.value = EMPTY; i.focus();
      var r = document.getElementById(NOM_RES); if(r) r.hidden = true;
    },

    verificar: function(e){
      e.preventDefault();
      var i = document.getElementById(NOM_INPUT),
          res = document.getElementById(NOM_RES),
          btn = document.getElementById(NOM_BTN);
      if(!i || !res) return false;
      var q = (i.value || EMPTY).toUpperCase().replace(/[^A-Z0-9]/g, EMPTY);
      var esVin = (i.dataset.modo === MODO_VIN) || q.length > 8;
      if(q.length < (esVin ? 11 : 5)){
        verifPinta(CLS_DUDA, ICO_DUDA, T_CORTO, esVin ? M_CORTO_VIN : M_CORTO_PAT, null, null);
        i.focus();
        return false;
      }
      res.hidden = false;
      res.className = CLS_RES + SP + CLS_CARGA;
      res.innerHTML = SPIN + M_BUSCANDO;
      if(btn){ btn.disabled = true; btn.textContent = T_BUSCANDO; }
      var PROD = window.ALLURE_PRODUCT || {};
      if(esVin || !PROD.id){
        verifFinal('NO_CONFIRMADO', esVin ? 'chasis' : EMPTY, q, null, null, null);
        verifRegistrar(null, esVin);
        if(btn){ btn.disabled = false; btn.textContent = T_VERIFICAR; }
        return false;
      }
      apiGet(EP_VERIF, {patente: q, producto: PROD.id})
        .then(function(r){
          verifVeredicto(r, q);
          if(!r || r.veredicto) verifRegistrar({vehiculo: verifVeh(r && r.vehiculo, null)}, esVin);
        })
        .catch(function(){ verifVeredicto(null, q); verifRegistrar(null, esVin); })
        .then(function(){ if(btn){ btn.disabled = false; btn.textContent = T_VERIFICAR; } });
      return false;
    },
  };

  /* Escape cierra el menú. Se registra una sola vez (el header se repinta, este listener no). */
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape' || e.keyCode===27){
      var p=document.getElementById('al-menu-panel');
      if(p && !p.hidden){ AL.menu(false); var b=document.getElementById('al-menu-btn'); if(b) b.focus(); }
    }
  });

  if(ONPROD){
    // Página /products/{handle}: renderiza el MISMO molde + activa data-view="ficha" para que
    // los bloques comunes (confianza/social/empresa) se muestren (la CSS los liga a esa vista).
    document.body.setAttribute('data-view','ficha');
    renderProducto(window.ALLURE_PRODUCT);
  } else if(ONSEARCH){
    document.body.setAttribute('data-view','buscar');
    renderBusqueda(window.ALLURE_SEARCH);
  } else {
    window.addEventListener('hashchange', route);
    if(!location.hash) location.hash='#home';
    route();
  }
})();
